import type { Clave } from "./es";

/**
 * El portal del socio en catalán.
 *
 * `Record<Clave, string>` es lo que hace que no se pueda olvidar ninguna
 * frase: si es.ts gana una clave y aquí no está, el programa no compila. Es
 * mejor que una prueba, porque salta antes de ejecutar nada.
 */
export const ca: Record<Clave, string> = {
  "general.cargando": "Carregant...",
  "general.unMomento": "Un moment...",
  "general.guardando": "Desant...",
  "general.guardar": "Desa",
  "general.guardado": "Desat",
  "general.cancelar": "Cancel·la",
  "general.cerrar": "Tanca",
  "general.volver": "Torna",
  "general.salir": "Surt",
  "general.entrar": "Entra",
  "general.enviando": "Enviant...",
  "general.idioma": "Idioma",
  "general.o": "o",
  "general.fallo": "No s'ha pogut completar l'operació",

  // El titulo de la pestaña: a menudo hay varias abiertas.
  "titulo.gestion": "Gestió del club",
  "titulo.portal": "El meu club",
  "titulo.carta": "Carta del local",
  "titulo.plataforma": "Panell de plataforma",
  "titulo.web": "asocis · Gestió d'associacions cannàbiques",
  "titulo.prueba": "Demanar una prova · asocis",
  "manifiesto.nombre": "Portal del soci",
  "manifiesto.descripcion":
    "El teu carnet, el teu consum, la teva quota i les notícies de la teva associació.",
  "carta.cargando": "Carregant la carta…",
  "carta.noDisponible": "Carta no disponible",
  "carta.noDisponibleAyuda":
    "Comprova l'enllaç, o demana al club que activi la carta des dels seus ajustos.",
  "carta.sinProducto": "Ara mateix no hi ha producte disponible.",
  "carta.pie": "Aportació solidària per a socis · Actualitzat a les {hora}",
  "carta.pieSinConexion":
    "Aportació solidària per a socis · Actualitzat a les {hora} · sense connexió, pot estar desactualitzat",
  "unidad.dia": "dia",
  "unidad.dias": "dies",

  "mov.recarga.EFECTIVO": "Recàrrega en efectiu",
  "mov.recarga.TARJETA": "Recàrrega amb targeta",
  "mov.recarga.TRANSFERENCIA": "Recàrrega per transferència",
  "mov.devolucion": "Devolució de saldo",
  "mov.dispensacion": "Dispensació #{numero}",
  "mov.dispensacionAnulada": "Anul·lació de la dispensació #{numero}",
  "mov.barra": "Barra #{numero}",
  "mov.barraAnulada": "Anul·lació de la barra #{numero}",
  "mov.donacion": "Donació al club",
  "cuota.anual": "Quota anual",
  "cuota.anios": "Quota de {n} anys",
  "cuota.unMes": "Quota d'un mes",
  "cuota.meses": "Quota de {n} mesos",
  "cuota.alta": "Quota d'alta",
  "pago.EFECTIVO": "Efectiu",
  "pago.CARTERA": "Cartera",
  "pago.TARJETA": "Targeta",
  "pago.TRANSFERENCIA": "Transferència",
  "movimiento.RECARGA": "Recàrrega",
  "movimiento.CONSUMO": "Consum",
  "movimiento.DEVOLUCION": "Devolució",
  "movimiento.AJUSTE": "Ajust",
  "movimiento.CUOTA": "Quota",
  "genetica.SATIVA": "Sativa",
  "genetica.INDICA": "Índica",
  "genetica.HIBRIDA": "Híbrida",
  "genetica.CBD": "CBD",
  "genetica.NA": "—",

  "portal.cabecera.socioNumero": "{nombre} · soci núm. {numero}",
  "portal.cabecera.contrasena": "Contrasenya",
  "portal.pestana.inicio": "El meu carnet",
  "portal.pestana.catalogo": "Disponible",
  "portal.pestana.reservas": "Les meves reserves",
  "portal.pestana.noticias": "Notícies",
  "portal.pestana.valoraciones": "Opinar",
  "portal.pestana.historial": "El meu historial",
  "portal.pestana.contrato": "Contracte",

  "entrada.titulo": "Portal del soci",
  "entrada.subtituloEntrar":
    "Consulta el teu consum, la teva quota i el teu carnet",
  "entrada.subtituloActivar": "Estrena el teu accés amb el codi del club",
  "entrada.club": "Club",
  "entrada.clubAyuda": "L'identificador que t'ha donat l'associació.",
  "entrada.numeroSocio": "Número de soci",
  "entrada.codigo": "Codi d'activació",
  "entrada.codigoAyuda": "Te'l donen al taulell. Caduca als 7 dies.",
  "entrada.contrasena": "Contrasenya",
  "entrada.eligeContrasena": "Tria una contrasenya",
  "entrada.minimo8": "Mínim 8 caràcters.",
  "entrada.repiteContrasena": "Repeteix la contrasenya",
  "entrada.crearAcceso": "Crea el meu accés",
  "entrada.primeraVez": "Primera vegada?",
  "entrada.activarAcceso": "Activa el meu accés",
  "entrada.yaTengoContrasena": "Ja tinc contrasenya",
  "entrada.noCoinciden": "Les dues contrasenyes no coincideixen",
  "entrada.accesoCreado":
    "Accés creat. Ja pots entrar amb la teva contrasenya.",

  "inicio.cuotaVencioHace":
    "La teva quota va vèncer fa {dias}. Passa pel club per renovar-la.",
  "inicio.cuotaVenceHoy": "La teva quota venç avui.",
  "inicio.cuotaVenceEn": "La teva quota venç d'aquí a {dias}.",
  "inicio.socio": "Soci",
  "inicio.numero": "Núm. {numero}",
  "inicio.socioDesde": "Soci des del {fecha}",
  "inicio.cuotaValidaHasta": "Quota vàlida fins al {fecha}",
  "inicio.generando": "Generant…",
  "inicio.ensenaCodigo": "Ensenya aquest codi al taulell per identificar-te.",
  "inicio.tuConsumo": "El teu consum",
  "inicio.hoy": "Avui",
  "inicio.esteMes": "Aquest mes",
  "inicio.puedesRetirar": "Pots retirar ara",
  "inicio.tuCartera": "La teva cartera",
  "inicio.saldoDisponible":
    "Saldo disponible per a les teves aportacions. Es recarrega al taulell.",
  "inicio.tuClub": "El teu club",
  "inicio.telefono": "Telèfon:",

  "avisos.titulo": "Avisos del club",
  "avisos.noSoportado":
    "Aquest navegador no admet avisos. Pots consultar les notícies entrant al portal.",
  "avisos.requiereInstalar1":
    "A l'iPhone cal afegir abans el portal a la pantalla d'inici: toca",
  "avisos.compartir": "Compartir",
  "avisos.yLuego": "i després",
  "avisos.anadirAInicio": "Afegeix a la pantalla d'inici",
  "avisos.requiereInstalar2": "Després podràs activar els avisos des d'aquí.",
  "avisos.activados":
    "Reps un avís en aquest dispositiu quan el club publica una notícia.",
  "avisos.sinActivar":
    "Activa els avisos per assabentar-te de les novetats del club sense entrar.",
  "avisos.desactivar": "Desactiva els avisos",
  "avisos.activar": "Activa els avisos",
  "avisos.enviarPrueba": "Envia una prova",
  "avisos.yaNo": "Ja no rebràs avisos en aquest dispositiu.",
  "avisos.listo": "Fet. T'avisarem quan el club publiqui alguna cosa.",
  "avisos.bloqueados":
    "El teu navegador té bloquejades les notificacions per a aquesta pàgina. Pots desbloquejar-les als seus ajustos.",
  "avisos.fallo":
    "No s'han pogut activar els avisos. Torna-ho a provar més tard.",
  "avisos.pruebaEnviada":
    "Avís de prova enviat: t'hauria d'arribar en uns segons.",
  "avisos.pruebaFallo": "No s'ha pogut enviar l'avís de prova.",

  "catalogo.vacio": "El club no té productes publicats ara mateix.",
  "catalogo.condiciones":
    "Les aportacions ja porten les teves condicions de soci. La disponibilitat pot canviar durant el dia.",
  "catalogo.sinSaldo":
    "Per reservar necessites saldo a la teva cartera. Passa pel club per recarregar-la i podràs demanar des d'aquí.",
  "catalogo.sinStock": "Sense estoc",
  "catalogo.quitarGramo": "Treu un gram",
  "catalogo.anadirGramo": "Afegeix un gram",
  "catalogo.faltan": "Et falten {importe} a la cartera",
  "catalogo.quedarian": "Et quedarien {importe} a la cartera",
  "catalogo.vaciar": "Buida",
  "catalogo.reservar": "Reserva",
  "catalogo.reservando": "Reservant...",
  "catalogo.falloReserva": "No s'ha pogut fer la reserva",
  "reservas.vacio":
    "Encara no has reservat res. Des de «Disponible» pots demanar el que vulguis i passar a recollir-ho.",
  "reservas.titulo": "Reserva {numero}",
  "reservas.PENDIENTE": "Pendent",
  "reservas.PENDIENTE.explica": "El club encara no l'ha preparat.",
  "reservas.PREPARADA": "Preparada",
  "reservas.PREPARADA.explica": "Ja la tenen a punt. Passa a recollir-la.",
  "reservas.ENTREGADA": "Lliurada",
  "reservas.ENTREGADA.explica": "Recollida.",
  "reservas.CANCELADA": "Cancel·lada",
  "reservas.CADUCADA": "Caducada",
  "reservas.CADUCADA.explica": "Va passar el termini sense recollir-la.",
  "reservas.total": "Total {cantidad}",
  "reservas.guardadaHasta":
    "Guardada fins al {fecha}. Passat aquest dia s'anul·la sola.",
  "reservas.falloCancelar": "No s'ha pogut cancel·lar",

  "noticias.vacio": "El club encara no ha publicat res.",

  "valoraciones.vacio":
    "Quan t'enduguis alguna cosa, aquí podràs dir què t'ha semblat. Al club li serveix per saber què torna a demanar.",
  "valoraciones.intro":
    "Digues què t'ha semblat el que t'has endut. Ho llegeix el club, per saber què torna a demanar.",
  "valoraciones.nDe5": "{n} de 5",
  "valoraciones.comentario": "Alguna cosa que vulguis explicar (opcional)",

  "historial.retiradas": "Les teves retirades",
  "historial.sinRetiradas": "Encara no has retirat res.",
  "historial.fecha": "Data",
  "historial.productos": "Productes",
  "historial.cantidad": "Quantitat",
  "historial.aportacion": "Aportació",
  "historial.anulada": "Anul·lada",
  "historial.cartera": "Moviments de la teva cartera",
  "historial.sinMovimientos": "Sense moviments.",
  "historial.concepto": "Concepte",
  "historial.importe": "Import",
  "historial.saldo": "Saldo",
  "historial.cuotas": "Les teves quotes",
  "historial.sinCuotas": "Sense quotes registrades.",
  "historial.validaHasta": "Vàlida fins a",

  "contrato.sinPublicar":
    "La teva associació encara no ha publicat aquí el seu contracte de soci.",
  "contrato.aceptaste": "Vas acceptar la",
  "contrato.version": "versió {numero}",
  "contrato.elDia": "el {fecha}",
  "contrato.esLaQueAplica": ". És la que se t'aplica.",
  "contrato.leeConCalma":
    "Llegeix-lo amb calma. En acceptar-lo queda constància de la data i de la versió, i podràs tornar a llegir-lo aquí sempre que vulguis.",
  "contrato.versionNueva":
    "L'associació ha publicat una versió més nova. El que vas signar continua sent el de dalt; pregunta al local si vols acceptar la nova.",
  "contrato.aceptar": "He llegit i accepto el contracte",
  "contrato.falloGuardar": "No s'ha pogut desar",

  "contrasena.titulo": "Canviar la meva contrasenya",
  "contrasena.actual": "Contrasenya actual",
  "contrasena.nueva": "Nova contrasenya",
  "contrasena.repite": "Repeteix la nova",
  "contrasena.cambiar": "Canvia",
  "contrasena.cambiada": "Contrasenya canviada.",
  "contrasena.fallo": "No s'ha pogut canviar la contrasenya",

  "alta.titulo": "Sol·licitar l'alta",
  "alta.clubNoEncontrado":
    "No trobem aquest club. Revisa l'enllaç que t'han donat.",
  "alta.nombre": "Nom *",
  "alta.apellidos": "Cognoms *",
  "alta.documento": "Document",
  "alta.pasaporte": "Passaport",
  "alta.numero": "Número *",
  "alta.fechaNacimiento": "Data de naixement *",
  "alta.mayorDeEdad": "Cal ser major de 18 anys.",
  "alta.telefono": "Telèfon",
  "alta.email": "Correu electrònic",
  "alta.ciudad": "Ciutat",
  "alta.avalista": "Núm. del soci que t'avala",
  "alta.avalistaAyuda": "Si algú de l'associació et presenta.",
  "alta.mensaje": "Missatge per al club",
  "alta.consentimiento":
    "Accepto que l'associació tracti les meves dades per estudiar aquesta sol·licitud.",
  "alta.consentimientoAyuda":
    "Si la rebutgen, les teves dades queden només al seu registre intern.",
  "alta.enviar": "Envia la sol·licitud",
  "alta.yaSoySocio": "Ja soc soci",
  "alta.enviada": "Sol·licitud enviada",
  "alta.enviadaTexto":
    "{club} la revisarà i es posarà en contacte amb tu. Recorda que l'alta es completa al local, presentant el teu document.",
  "alta.elClub": "El club",
  "alta.fallo": "No s'ha pogut enviar la sol·licitud",

  "err.clubNoEncontrado": "No trobem aquest club",
  "err.codigoNoValido": "El número de soci o el codi no són correctes, o el codi ha caducat",
  "err.entradaIncorrecta": "Número de soci o contrasenya incorrectes",
  "err.passwordActualMal": "La contrasenya actual no és correcta",
  "err.soloLoQueTeLlevaste": "Només pots opinar del que t'has endut",
  "err.sinContrato": "Aquest club encara no té contracte de soci",
  "err.reservaNoEncontrada": "No trobem aquesta reserva",
  "err.reservaNoPendiente": "Aquesta reserva ja no està pendent",
  "err.reservaCerrada": "Aquesta reserva ja està tancada",
  "err.yaTienesReserva":
    "Ja tens la reserva número {numero} pendent de recollir. Cancel·la-la si vols demanar una altra cosa.",
  "err.productoNoEncontrado": "No trobem aquest producte",
  "err.pasaDelMes": "Demanes més del que et queda aquest mes. Et queden {cantidad}.",
  "err.sinSaldo":
    "Per reservar necessites saldo a la teva cartera. Demanes {total} i en tens {saldo}. Passa pel club per recarregar-la i torna-ho a provar.",
  "err.mayorDeEdad": "Cal ser major de 18 anys",
  "err.nacimientoNoValido": "La data de naixement no és vàlida",
  "err.consentimiento": "Cal acceptar el tractament de dades",
  "err.idiomaNoExiste": "Aquest idioma no existeix",
  "err.bloqueo.baja": "La teva alta ja no està activa. Parla amb el club.",
  "err.bloqueo.suspendido": "La teva alta està suspesa. Parla amb el club.",
  "err.bloqueo.pendiente": "La teva alta està pendent de validar. Passa pel club per completar-la.",
  "err.bloqueo.cuotaCaducada": "La teva quota està vençuda. Passa pel club per renovar-la.",
  "err.bloqueo.cuotaVencida": "La teva quota ha vençut: cal renovar-la. Passa pel club.",
  "servidor.El socio está dado de baja": "El soci està donat de baixa",
  "servidor.El socio está suspendido": "El soci està suspès",
  "servidor.El alta del socio está pendiente de validar":
    "L'alta del soci està pendent de validar",
  "servidor.La cuota del socio está caducada":
    "La quota del soci està caducada",
  "servidor.La cuota del socio ha caducado: hay que renovarla":
    "La quota del soci ha caducat: cal renovar-la",

  "web.entrar": "Entra",
  "web.frase":
    "asocis és el programa per portar una associació cannàbica: socis, taulell, inventari per lots, caixa i portal del soci.",
  "web.fraseSegunda":
    "A sota tens el seu taulell, funcionant amb dades inventades. Tria un soci, toca productes, passa't del seu límit, cobra.",
  "web.altasUnaAUna":
    "Les altes van d'una en una: et donem un codi i amb ell muntes el teu club en un minut.",
  "web.yaTienesUno": "Ja en tens un?",
  "web.pedirPrueba": "Demana una prova",
  "web.pedirAcceso": "Demana accés",
  "web.probarGratis": "Prova {dias} gratis",
  "web.crearClub": "Crea el meu club",
  "web.pieDemo":
    "Amb les teves dades fa el mateix. El que no hi cap aquí: el cercador per nom, número o document; el lector del carnet QR; les categories del catàleg; els descomptes a mà; i la resta del menú.",

  "web.detras": "El que hi ha darrere del taulell",
  "web.detras.socios": "Socis",
  "web.detras.socios.texto":
    "Alta amb document, foto, avalador, consum declarat i consentiment amb data. Tipus de soci amb la seva quota, el seu descompte i els seus límits. El llibre de socis que l'associació està obligada a portar, a punt per imprimir. I «Importa CSV» per portar-los del teu programa anterior.",
  "web.detras.limites": "Límits",
  "web.detras.limites.texto":
    "Cada soci té un topall diari i un altre de mensual. El taulell compara la comanda amb el que porta; si se'n passa, cal autoritzar-ho i queda apuntat qui ho va fer. Un soci amb la quota caducada no dispensa fins que renovi.",
  "web.detras.inventario": "Inventari per lots",
  "web.detras.inventario.texto":
    "Les entrades van per lot, amb proveïdor, cost i caducitat. El taulell consumeix del més antic, les minves porten motiu i els recomptes comparen el que s'ha comptat amb el que hi hauria d'haver. De cada gram lliurat se sap de quin lot va sortir.",
  "web.detras.caja": "Caixa",
  "web.detras.caja.texto":
    "El torn obre amb un fons, recull dispensacions, barra i despeses en efectiu, i en tancar es compta el calaix: el programa diu el que hi hauria d'haver i la diferència. Les despeses domiciliades no toquen la caixa.",
  "web.detras.cartera": "Cartera",
  "web.detras.cartera.texto":
    "Moneder de prepagament del soci: recàrregues, consum, devolucions. Al taulell es cobra de la cartera amb un toc, i si no cobreix, ho diu.",
  "web.detras.barra": "Barra",
  "web.detras.barra.texto":
    "Cafès, refrescos i snacks amb la seva carta i el seu cobrament ràpid. Van a la mateixa caixa, però l'arqueig distingeix barra de dispensació.",
  "web.detras.portal": "Portal del soci",
  "web.detras.portal.texto":
    "Al seu mòbil, com una aplicació: el carnet amb QR per identificar-se al taulell, el seu consum davant dels seus límits, la seva cartera, el catàleg amb el seu preu, les notícies del club i reserves per passar a recollir. En {idiomas}.",
  "web.detras.cuotas": "Quotes i renovacions",
  "web.detras.cuotas.texto":
    "Cobrament, venciments, i un recordatori per correu abans que caduquin. Les donacions van a part, perquè no moguin la data de ningú.",
  "web.detras.gastos": "Despeses i compres",
  "web.detras.gastos.texto":
    "El que es deu al proveïdor i el que s'ha pagat, amb categoria, a la mateixa pantalla. Exportació per a la gestoria.",
  "web.detras.acceso": "Accés i aforament",
  "web.detras.acceso.texto":
    "Qui hi ha dins ara i quanta gent ha passat avui. Amb aforament, en omplir-se avisa: no tanca la porta.",
  "web.detras.informes": "Informes",
  "web.detras.informes.texto":
    "D'on ve el diner per dia o per mes, separant dispensació, barra i quotes. Rànquing de productes i de socis.",
  "web.detras.carta": "Carta per a la pantalla del local",
  "web.detras.carta.texto":
    "Una pàgina a pantalla completa amb el que hi ha avui i el seu preu, que aguanta un tall de xarxa.",

  "web.precio": "Preu",
  "web.precio.texto":
    "Va per mida, i compten els socis <b>actius</b>: les baixes d'anys anteriors no et pugen el preu. Totes les funcions i tot l'equip entren en qualsevol tram.",
  "web.precio.sociosActivos": "Socis actius",
  "web.precio.alMes": "Al mes",
  "web.precio.hablamos": "En parlem",
  "web.precio.consultanos": "Consulta'ns",
  "web.tramo.hasta": "Fins a {hasta} socis",
  "web.tramo.entre": "De {desde} a {hasta} socis",
  "web.tramo.mas": "Més de {desde} socis",
  "web.precio.prueba":
    "{dias} de prova per veure-ho amb les teves dades de veritat.",
  "web.precio.condiciones":
    "Sense permanència: si ho deixes, t'endus les teves dades, i pots descarregar-te el club sencer en un fitxer quan vulguis, també el dia que marxes. Si el club creix i canvia de tram, t'avisem abans; mai no es bloqueja res. Les actualitzacions van incloses.",

  "web.datos": "Sobre les dades",
  "web.datos.texto":
    "Un club gestiona documents d'identitat, fotos i consum dels seus socis: dades personals de gent de veritat. Cada club està aïllat dels altres, les contrasenyes es desen xifrades i tot el que es fa queda en un registre d'activitat amb qui i quan. Es fa una còpia de seguretat de cada club cada nit, i el club se la pot descarregar ell mateix. La tauleta del taulell es bloqueja sola si ningú no la toca.",
  "web.datos.nota":
    "El programa et dona les eines; el contracte d'encarregat del tractament amb els teus socis i la política de conservació els defineixes tu, com amb qualsevol altre proveïdor.",
  "web.empezar": "Com es comença",
  "web.empezar.nosEscribes": "Ens escrius",
  "web.empezar.conCodigo":
    "i et contestem amb un codi d'alta. Van d'una en una a propòsit: cada club comença amb algú a l'altre costat.",
  "web.empezar.creasClub": "Crees el teu club",
  "web.empezar.sinCodigo":
    "amb el nom, les dades de l'associació i el teu compte de propietari. Un minut.",
  "web.empezar.despues":
    "Després poses els teus tipus de soci, la quota, els límits i el catàleg —el que no posis té un valor raonable de sèrie—, i portes els teus socis amb «Importa CSV», que llegeix el registre del teu programa anterior. El mateix dia ja tens taulell.",
  "web.pie": "asocis · Gestió d'associacions cannàbiques",
  "web.pie.avisoLegal": "Avís legal",
  "web.pie.privacidad": "Privacitat",

  "web.demoEnCastellano":
    "Aquest taulell de mostra només és en castellà; el programa de veritat i el portal del soci són en {idiomas}.",
  "prueba.titulo": "Demana una prova",
  "prueba.intro":
    "Les altes van d'una en una: et contestem amb un codi i amb ell muntes el teu club en un minut. Si ens dius quants socis sou, et diem ja el que us toca pagar.",
  "prueba.nombreClub": "Nom de l'associació",
  "prueba.ciudad": "Ciutat",
  "prueba.socios": "Socis, aproximadament",
  "prueba.sociosAyuda": "Opcional. És el que decideix el preu.",
  "prueba.tuNombre": "El teu nom",
  "prueba.tuEmail": "El teu correu",
  "prueba.tuEmailAyuda": "Allà t'enviem el codi.",
  "prueba.telefono": "Telèfon",
  "prueba.telefonoAyuda": "Opcional, per si és més fàcil trucar-te.",
  "prueba.mensaje": "Alguna cosa que hàgim de saber?",
  "prueba.mensajeAyuda":
    "Opcional. Com ho porteu ara, què us falta, quan voleu començar.",
  "prueba.privacidad1": "He llegit la",
  "prueba.privacidad2": "política de privacitat",
  "prueba.privacidad3": "i accepto que useu aquestes dades per contestar-me.",
  "prueba.enviar": "Demana la prova",
  "prueba.fallo": "No s'ha pogut enviar la sol·licitud",
  "prueba.recibido": "Rebut.",
  "prueba.recibidoTexto1": "T'escrivim a",
  "prueba.recibidoTexto2": "amb el codi per donar d'alta",
  "prueba.recibidoTexto3":
    ", normalment en un dia laborable. Si no el veus, mira al correu brossa.",
  "prueba.volverWeb": "Torna a la web",

  "g.cargando": "Carregant...",
  "g.cancelar": "Cancel·la",
  "g.cerrar": "Tanca",
  "g.guardar": "Desa",
  "g.anterior": "Anterior",
  "g.siguiente": "Següent",
  "g.pagina": "Pàgina {pagina} de {paginas}",
  "g.estado.ACTIVO": "Actiu",
  "g.estado.PENDIENTE": "Pendent",
  "g.estado.CADUCADO": "Caducat",
  "g.estado.SUSPENDIDO": "Suspès",
  "g.estado.BAJA": "Baixa",

  "m.titulo": "Taulell",
  "m.descripcion": "Registre de lliurament a soci",
  "m.dudaDeGuardado1": "Mira a",
  "m.dudaDeGuardado2":
    "si el lliurament s'ha arribat a registrar. Si hi és, no el repeteixis.",
  "m.dispensaciones": "Dispensacions",
  "m.reservas": "Reserves per recollir",
  "m.socio": "Soci",
  "m.pedido": "Comanda",
  "m.total": "Total",
  "m.reservaNumero": "Reserva {numero}",
  "m.faltaGenero": "Falta gènere",
  "m.cancelarReserva": "Cancel·la",
  "m.can.titulo": "Cancel·la la reserva #{numero}",
  "m.can.quePasa":
    "El soci veurà la reserva cancel·lada amb el motiu que escriguis i podrà tornar a demanar. Si té el portal al mòbil, li arriba un avís.",
  "m.can.motivo": "Motiu, el llegeix el soci",
  "m.can.confirmar": "Sí, cancel·la la reserva",
  "m.can.fallo": "No s'ha pogut cancel·lar la reserva",
  "m.can.hecho": "Reserva cancel·lada",
  "m.atender": "Atén",
  "m.aQuien": "A qui es dispensa?",
  "m.comoBuscar":
    "Escriu almenys dues lletres del nom, el número de soci o el document.",
  "m.todo": "Tot",
  "m.sinProductos": "No hi ha productes disponibles en aquesta categoria.",
  "m.reservado": "{cantidad} reservats",
  "m.sinStock": "Sense estoc",
  "m.cambiar": "Canvia",
  "m.hoy": "Avui",
  "m.esteMes": "Aquest mes",
  "m.cartera": "Cartera",
  "m.ingresar": "+ Ingressa",
  "m.ingresarTitulo": "Ingressa diners a la seva cartera",
  "m.cuotaVencioHace": "La quota va vèncer fa {dias}.",
  "m.cuotaVenceHoy": "La quota venç avui.",
  "m.cuotaVenceEn": "La quota venç d'aquí a {dias}.",
  "m.cobrarAhora": "Cobra ara",
  "m.entrega": "Lliurament",
  "m.tocaProducto": "Toca un producte per afegir-lo.",
  "m.quitar": "Treu",
  "m.ahorro": "Estalvi {importe}",
  "m.descuentoAMano": "Descompte a mà −{importe}",
  "m.descuento": "Descompte",
  "m.quitarDescuento": "Treu el descompte",
  "m.hacerDescuento": "Fes descompte",
  "m.superaLimiteCorto": "Supera el límit disponible ({disponible}).",
  "m.registrando": "Registrant...",
  "m.registrar": "Registra el lliurament · {total}",
  "m.irACobrar": "Vés a cobrar",
  "m.falloRegistrar": "No s'ha pogut registrar la dispensació",
  "m.superaLimite":
    "Supera el límit disponible: pot endur-se {disponible} i se'n demanen {pedido}",
  "m.soloPropietario":
    "Només un encarregat o superior pot autoritzar passar del límit",

  "m.sinFichar.titulo": "No ha fitxat l'entrada",
  "m.sinFichar.texto":
    "no consta dins del local. Li pots fitxar l'entrada ara i seguir amb el lliurament.",
  "m.sinFichar.nota":
    "Si segueixes sense fitxar, el lliurament es registra igualment, però el soci no comptarà a l'aforament ni al llibre d'entrades del dia.",
  "m.sinFichar.seguir": "Segueix sense fitxar",
  "m.sinFichar.fichar": "Fitxa i segueix",
  "m.sinFichar.fichando": "Fitxant...",
  "m.sinFichar.fallo": "No s'ha pogut fitxar l'entrada",
  "m.limite.titulo": "Se supera el límit",
  "m.limite.autorizar": "Autoritza i registra",
  "m.limite.nota":
    "Només un encarregat o superior pot autoritzar-ho. L'autorització queda registrada a l'historial d'auditoria amb el teu nom.",
  "m.venta.enCola": "Lliurament desat en aquesta tauleta",
  "m.venta.registrada": "Lliurament #{numero} registrat",
  "m.venta.quedan": "Queden {importe} a la cartera",

  "s.titulo": "Socis",
  "s.enElRegistro": "{socios} al registre",
  "s.exportar": "Exporta CSV",
  "s.libro": "Llibre de socis",
  "s.importar": "Importa CSV",
  "s.carnets": "Carnets",
  "s.nuevo": "+ Nou soci",
  "s.falloExportar": "No s'ha pogut exportar",
  "s.buscar": "Cerca per nom, número o document...",
  "s.todosLosEstados": "Tots els estats",
  "s.cualquierTipo": "Qualsevol tipus",
  "s.hanVenidoDesde": "Han vingut des de",
  "s.sinCoincidencias": "No hi ha socis que coincideixin amb la cerca.",
  "s.sinSocios": "Encara no hi ha socis.",
  "s.darDeAlta": "Dona d'alta el primer",
  "s.oImportar": "importar els que ja teniu",
  "s.numero": "Núm.",
  "s.socio": "Soci",
  "s.documento": "Document",
  "s.estado": "Estat",
  "s.cuotaHasta": "Quota fins a",
  "s.ultimaVisita": "Última visita",
  "s.aportado": "Aportat",
  "s.cartera": "Cartera",
  "s.anios": "{anios} anys",
  "s.sinTelefono": "sense telèfon",
  "s.queda": "queda {dias}",
  "s.quedan": "queden {dias}",
  "s.nunca": "Mai",
  "s.hoy": "avui",
  "s.ayer": "ahir",
  "s.haceDias": "fa {dias} dies",
  "s.haceUnMes": "fa un mes",
  "s.haceMeses": "fa {meses} mesos",
  "s.haceUnAnio": "fa un any",
  "s.haceAnios": "fa {anios} anys",

  "b.marcador": "Cerca un soci per nom, número o DNI...",
  "b.escanear": "Escaneja el carnet del soci",
  "b.sinCoincidencias": "Cap soci coincideix amb «{texto}»",
  "b.codigoDesconocido": "Aquest codi no correspon a cap soci d'aquest club.",
  "b.falloCodigo": "No s'ha pogut comprovar el codi. Torna-ho a provar.",
  "b.escanearBoton": "Escaneja",
  "b.qr.sinCamara": "Aquest navegador no dona accés a la càmera. Escriu el número de soci a mà.",
  "b.qr.sinPermiso": "No has donat permís per fer servir la càmera. El pots donar al cadenat de la barra d'adreces.",
  "b.qr.sinDispositivo": "No s'ha trobat cap càmera en aquest dispositiu.",
  "b.qr.falloCamara": "No s'ha pogut obrir la càmera. Escriu el número de soci a mà.",
  "b.qr.apunta": "Apunta al codi del soci. S'identifica sol de seguida que el llegeixi.",
  "m.productos": "{n} productes",
  "m.unProducto": "1 producte",

  "c.titulo": "Caixa",
  "c.descripcion": "Torns de caixa i arqueig de l'efectiu",
  "c.entradaSalida": "Entrada / sortida",
  "c.cerrarCaja": "Tanca la caixa",
  "c.abrirCaja": "Obre la caixa",
  "c.sinCaja":
    "No tens cap caixa oberta. Mentre segueixi tancada, els cobraments en efectiu no s'anotaran en cap arqueig.",
  "c.otraAbierta":
    "Hi ha una altra caixa oberta al club, i el que cobris tu no hi entra.",
  "c.otrasAbiertas":
    "Hi ha {n} caixes obertes més al club, i el que cobris tu no hi entra.",
  "c.fondoInicial": "Fons inicial",
  "c.abiertaALas": "Oberta a les {hora}",
  "c.dispensaciones": "Dispensacions",
  "c.barra": "Barra",
  "c.cuotasYRecargas": "Quotes i recàrregues",
  "c.gastos": "Despeses",
  "c.deberiaHaber": "Hi hauria d'haver",
  "c.formula": "Fons + entrades − sortides",
  "c.movimientos": "Moviments del torn",
  "c.sinMovimientos": "Encara no hi ha moviments en aquest torn.",
  "c.hora": "Hora",
  "c.tipo": "Tipus",
  "c.concepto": "Concepte",
  "c.usuario": "Usuari",
  "c.importe": "Import",
  "c.historial": "Historial de torns",

  "c.fa.titulo": "Efectiu fora d'arqueig",
  "c.fa.explicacion":
    "{cuantos} vegades s'ha cobrat en efectiu sense cap caixa oberta, {importe} en total: aquests diners són al calaix i no entren a l'arqueig de cap torn. Passa quan es cobra amb la caixa tancada, i amb els lliuraments fets sense xarxa que s'envien quan el torn de qui els va fer ja s'ha acabat.",
  "c.fa.explicacionUno":
    "Un cobrament de {importe} en efectiu es va fer sense cap caixa oberta: aquests diners són al calaix i no entren a l'arqueig de cap torn. Passa quan es cobra amb la caixa tancada, i amb els lliuraments fets sense xarxa que s'envien quan el torn de qui els va fer ja s'ha acabat.",
  "c.fa.cuando": "Quan",
  "c.fa.que": "Què",
  "c.fa.importe": "Import",
  "c.fa.hayMas": "Només es veuen els 100 més recents.",
  "c.fa.tipo.DISPENSACION": "Dispensació",
  "c.fa.tipo.BARRA": "Barra",
  "c.fa.tipo.CUOTA": "Quota",
  "c.fa.tipo.DONACION": "Donació",
  "c.fa.tipo.RECARGA": "Recàrrega",
  "c.fa.tipo.GASTO": "Despesa",
  "c.sinTurnos": "Encara no s'ha tancat cap torn.",
  "c.apertura": "Obertura",
  "c.cierre": "Tancament",
  "c.responsable": "Responsable",
  "c.teorico": "Teòric",
  "c.contado": "Comptat",
  "c.diferencia": "Diferència",
  "c.abierta": "Oberta",
  "c.cuadra": "Quadra",
  "c.abrir.titulo": "Obre la caixa",
  "c.abrir.fondo": "Fons de caixa inicial (crèdits)",
  "c.abrir.fondoAyuda": "Diners amb què comença el torn.",
  "c.abrir.notas": "Notes",
  "c.abrir.notasEjemplo": "Torn de tarda...",
  "c.abrir.boton": "Obre",
  "c.abrir.fallo": "No s'ha pogut obrir la caixa",
  "c.cerrar.titulo": "Tanca la caixa",
  "c.cerrar.segunSistema": "Segons el sistema hi hauria d'haver",
  "c.cerrar.contado": "Diners comptats al calaix (crèdits)",
  "c.cerrar.descuadre": "Descompensament de",
  "c.cerrar.sobra": "(sobren diners).",
  "c.cerrar.falta": "(falten diners).",
  "c.cerrar.cuadra": "La caixa quadra exactament.",
  "c.cerrar.observaciones": "Observacions del tancament",
  "c.cerrar.boton": "Tanca el torn",
  "c.cerrar.fallo": "No s'ha pogut tancar la caixa",
  "c.mov.titulo": "Moviment de caixa",
  "c.mov.tipo": "Tipus",
  "c.mov.salida": "Retirada d'efectiu",
  "c.mov.entrada": "Entrada d'efectiu",
  "c.mov.nota1": "Per a una factura o una compra, fes servir",
  "c.mov.gastos": "Despeses",
  "c.mov.nota2": ": a més de sortir de la caixa queda classificada.",
  "c.mov.importe": "Import (crèdits)",
  "c.mov.concepto": "Concepte",
  "c.mov.conceptoEjemplo": "Compra de material...",
  "c.mov.boton": "Registra",
  "c.mov.fallo": "No s'ha pogut registrar el moviment",
  "movimiento.ENTRADA": "Entrada",
  "movimiento.SALIDA": "Sortida",
  "movimiento.DISPENSACION": "Dispensació",
  "movimiento.MERMA": "Minva",
  "movimiento.GASTO": "Despesa",

  "i.titulo": "Inventari",
  "i.descripcion": "Entrades, minves i recomptes d'estoc",
  "i.almacen": "Magatzem",
  "i.movimientos": "Moviments",
  "i.exportar": "Exporta CSV",
  "i.falloExportar": "No s'ha pogut exportar",
  "i.enElMostrador": "Al taulell",
  "i.valor": "Valor de l'inventari",
  "i.valorPie": "Segons l'aportació del catàleg",
  "i.coste": "Cost del que queda",
  "i.costePie": "El que se'n va pagar",
  "i.avisos": "Avisos",
  "i.avisosPie": "{bajos} sota mínim · {caducan} per caducar",
  "i.porCaducar": "Lots pròxims a caducar:",
  "i.buscar": "Cerca un producte o categoria...",
  "i.nProductos": "{n} productes",
  "i.unProducto": "1 producte",
  "i.sinProductos": "No hi ha productes. Crea'ls primer al catàleg.",
  "i.producto": "Producte",
  "i.categoria": "Categoria",
  "i.unidad": "Unitat",
  "i.enVenta": "Taulell",
  "i.guardado": "Guardat",
  "i.total": "Total",
  "i.minimo": "Mínim",
  "i.lotes": "Lots",
  "i.caduca": "Caduca",
  "i.valorColumna": "Valor",
  "i.costeColumna": "Cost",
  "i.bajoMinimo": "sota mínim",
  "i.inactivo": "Inactiu",
  "i.entrada": "Entrada",
  "i.merma": "Minva",
  "i.ajuste": "Ajust",
  "i.ultimos": "Últims moviments",
  "i.sinRegistros": "Sense moviments registrats.",
  "i.fecha": "Data",
  "i.tipo": "Tipus",
  "i.cantidad": "Quantitat",
  "i.op.entrada": "Entrada de {producto}",
  "i.op.merma": "Minva de {producto}",
  "i.op.ajuste": "Ajust de {producto}",
  "i.op.stockActual": "Estoc actual:",
  "i.op.cantidad": "Quantitat",
  "i.op.stockContado": "Estoc real comptat",
  "i.op.ajusteAyuda": "Es registrarà la diferència amb l'estoc del sistema.",
  "i.op.codigoLote": "Codi de lot",
  "i.op.codigoAyuda": "Es genera sol si el deixes buit.",
  "i.op.costeTotal": "Cost total (crèdits)",
  "i.op.proveedor": "Origen / proveïdor",
  "i.op.caducidad": "Caducitat",
  "i.op.motivo": "Motiu",
  "i.op.motivoAyuda": "Queda registrat a l'historial.",
  "i.op.registrar": "Registra",
  "i.op.fallo": "No s'ha pogut registrar l'operació",
  "i.gd.titulo": "Guardat · {producto}",
  "i.gd.enVenta": "Taulell:",
  "i.gd.guardado": "Guardat:",
  "i.gd.queSeHace": "Què es fa",
  "i.gd.aVenta": "Treure del guardat al taulell",
  "i.gd.aGuardado": "Retirar del taulell al guardat",
  "i.gd.comoMucho": "Com a màxim {cantidad}.",
  "i.gd.motivoAyuda": "Opcional. Queda a l'historial de moviments.",
  "i.gd.moviendo": "Movent...",
  "i.gd.sacar": "Treu al taulell",
  "i.gd.fallo": "No s'ha pogut moure",
  "g.guardando": "Desant...",
  "i.guardadosPie": "{cantidad} guardats",

  "ba.titulo": "Barra",
  "ba.descripcion": "Cafès, refrescos i tot el que no és dispensació",
  "ba.carta": "Carta de la barra",
  "ba.vacia": "La carta de la barra és buida.",
  "ba.vaciaAdmin": " Afegeix el que veneu amb «Carta de la barra».",
  "ba.vaciaSocio": " Demana a un administrador que la prepari.",
  "ba.sinExistencias": "Sense existències",
  "ba.agotado": "Esgotat",
  "ba.quedan": "En queden {n}",
  "ba.cobro": "Cobrament",
  "ba.tocaProducto": "Toca un producte per començar.",
  "ba.cadaUno": "{importe} c/u",
  "ba.vaciar": "Buida",
  "ba.cobrando": "Cobrant...",
  "ba.cobrar": "Cobra {total}",
  "ba.faltaSocio": "Per cobrar de la cartera cal triar el soci.",
  "ba.hoy": "Barra d'avui",
  "ba.unCobro": "1 cobrament",
  "ba.cobros": "{n} cobraments",
  "ba.ultimos": "Últims cobraments",
  "ba.sinCobros": "Avui encara no s'ha cobrat res a la barra.",
  "ba.anulada": "Anul·lada",
  "ba.falloCobrar": "No s'ha pogut cobrar",
  "ba.cobrado": "Cobrat {importe} · tiquet de barra {numero}",
  "ba.c.nombre": "Nom",
  "ba.c.nombreEjemplo": "Cafè amb llet",
  "ba.c.grupo": "Grup",
  "ba.c.grupoAyuda": "Per agrupar-los a la pantalla.",
  "ba.c.grupoPorDefecto": "Begudes",
  "ba.c.precio": "Preu (crèdits)",
  "ba.c.existencias": "Existències",
  "ba.c.existenciasAyuda": "Només si vols portar-ne el compte.",
  "ba.c.llevarCuenta": "Portar el compte de les existències",
  "ba.c.llevarCuentaNota": "El cafè de la màquina no necessita compte; una caixa de llaunes sí.",
  "ba.c.anadir": "Afegeix a la carta",
  "ba.c.producto": "Producte",
  "ba.c.precioColumna": "Preu",
  "ba.c.quedan": "en queden {n}",
  "ba.c.quitar": "Treu",
  "ba.c.reponer": "Reposa",
  "ba.c.fallo": "No s'ha pogut desar",

  "d.titulo": "Dispensacions i barra",
  "d.descripcion": "Tot el que ha sortit, tiquet a tiquet",
  "d.a": "a",
  "d.exportar": "Exporta CSV",
  "d.falloExportar": "No s'ha pogut exportar",
  "d.dispensario": "Dispensari",
  "d.barra": "Barra",
  "d.buscar": "Cerca soci, producte o núm. de tiquet",
  "d.atendioCualquiera": "Ha atès qualsevol",
  "d.baja": " (baixa)",
  "d.todosLosPuestos": "Tots els llocs",
  "d.todos": "Tots",
  "d.soloValidos": "Només vàlids",
  "d.soloAnulados": "Només anul·lats",
  "d.quitarFiltros": "Treu els filtres",
  "d.entregas": "Lliuraments",
  "d.cobros": "Cobraments",
  "d.unAnulado": "1 anul·lat",
  "d.anulados": "{n} anul·lats",
  "d.cantidad": "Quantitat",
  "d.aportaciones": "Aportacions",
  "d.deDescuento": "{importe} de descompte",
  "d.aMano": "{importe} a mà",
  "d.sinCoincidencias": "Cap tiquet no coincideix amb el que cerques.",
  "d.sinDispensaciones": "No hi ha dispensacions en aquest període.",
  "d.sinCobros": "No s'ha cobrat res a la barra en aquest període.",
  "d.numero": "Núm.",
  "d.fecha": "Data",
  "d.socio": "Soci",
  "d.productos": "Productes",
  "d.articulos": "Articles",
  "d.descuento": "Descompte",
  "d.importe": "Import",
  "d.atendio": "Ha atès",
  "d.laSubio": "La va pujar {nombre}",
  "d.sinSocio": "Sense soci",
  "d.anulada": "Anul·lada",
  "d.sinConexion": "Sense connexió",
  "d.sinConexionAyuda": "Feta sense xarxa i enviada en tornar la connexió",
  "d.descuentoAMano": "a mà {importe}",
  "d.ticket": "Tiquet",
  "d.anular": "Anul·la",
  "d.tope":
    "Es veuen els cobraments més recents del període, fins a un màxim de {tope}. Escurça les dates per veure la resta.",
  "d.ticketNumero": "Tiquet #{numero}",
  "d.imprimir": "Imprimeix",
  "d.an.tituloDispensacion": "Anul·la la dispensació #{numero}",
  "d.an.tituloVenta": "Anul·la la venda #{numero}",
  "d.an.dispensario": "Es tornarà {cantidad} a l'estoc.",
  "d.an.dispensarioCartera": "Es tornarà {cantidad} a l'estoc i es reintegraran {importe} a la cartera del soci.",
  "d.an.dispensarioCaja": "Es tornarà {cantidad} a l'estoc i es registrarà la sortida de {importe} a la caixa.",
  "d.an.barra": "Es tornaran les unitats a l'estoc de la barra.",
  "d.an.barraCartera":
    "Es tornaran les unitats a l'estoc de la barra i es reintegraran {importe} a la cartera del soci.",
  "d.an.barraCaja":
    "Es tornaran les unitats a l'estoc de la barra i es registrarà la sortida de {importe} a la caixa.",
  "d.an.motivo": "Motiu de l'anul·lació",
  "d.an.anular": "Anul·la",
  "d.an.fallo": "No s'ha pogut anul·lar",

  "tk.preparando": "Preparant el tiquet...",
  "tk.ticket": "Tiquet #{numero}",
  "tk.socio": "Soci #{numero}",
  "tk.atiende": "Atén",
  "tk.anulada": "*** ANUL·LADA ***",
  "tk.unidades": "{cantidad} u. x {precio}",
  "tk.gramos": "{cantidad} g x {precio}/g",
  "tk.catalogo": "{texto} · catàleg {importe}",
  "tk.total": "TOTAL",
  "tk.descuentoAplicado": "Descompte aplicat",
  "tk.descuento": "Descompte",
  "tk.descuentoCon": "Descompte {texto}",
  "tk.totalDispensado": "Total dispensat",
  "tk.formaDePago": "Forma de pagament",
  "tk.saldoRestante": "Saldo restant",
  "tk.documentoInterno": "Document intern de l'associació. No és una factura.",

  "nav.gestionDe": "Gestió de l'associació",
  "nav.inicio": "Inici",
  "nav.mostrador": "Taulell",
  "nav.grupoAsociacion": "Associació",
  "nav.donaciones": "Donacions",
  "nav.socios": "Socis",
  "nav.caja": "Caixa",
  "nav.gastos": "Despeses i compres",
  "nav.inventario": "Inventari",
  "nav.recuentos": "Recomptes",
  "nav.barra": "Barra",
  "nav.dispensaciones": "Dispensacions",
  "nav.descuentos": "Descomptes",
  "nav.grupoAjustes": "Ajustos",
  "nav.informes": "Informes",
  "nav.ajustes": "Ajustos",
  "nav.dias": "Dies",
  "nav.contrato": "Contracte",
  "nav.accesos": "Accessos",
  "nav.renovaciones": "Renovacions",
  "nav.cuotas": "Quotes",
  "nav.comunidad": "Comunitat",
  "nav.catalogo": "Catàleg",
  "nav.cartas": "Cartes",
  "nav.contrasena": "Contrasenya",
  "rol.PROPIETARIO": "Propietari",
  "rol.TRABAJADOR": "Treballador",
  "nav.pw.titulo": "Canvia la meva contrasenya",
  "nav.pw.hecho": "Contrasenya canviada. Fes-la servir la propera vegada que entris.",
  "nav.pw.actual": "Contrasenya actual",
  "nav.pw.nueva": "Contrasenya nova",
  "nav.pw.minimo": "Mínim 8 caràcters.",
  "nav.pw.repetir": "Repeteix la nova",
  "nav.pw.noCoinciden": "No coincideixen.",
  "nav.pw.cambiar": "Canvia",
  "nav.pw.fallo": "No s'ha pogut canviar la contrasenya",

  "p.buenosDias": "Bon dia",
  "p.buenasTardes": "Bona tarda",
  "p.buenasNoches": "Bona nit",
  "p.saludo": "{saludo}, {nombre}",
  "p.descripcion": "Resum de l'activitat del club",
  "p.nuevaDispensacion": "Nova dispensació",
  "p.sinCaja": "No hi ha cap caixa oberta. Els cobraments en efectiu no quedaran registrats a l'arqueig.",
  "p.abrirCaja": "Obre la caixa",
  "p.unaSolicitud": "Hi ha 1 sol·licitud d'alta esperant resposta.",
  "p.solicitudes": "Hi ha {n} sol·licituds d'alta esperant resposta.",
  "p.verSolicitudes": "Mira les sol·licituds",
  "p.unaCuotaVencida": "1 soci amb la quota vençuda.",
  "p.cuotasVencidas": "{n} socis amb la quota vençuda.",
  "p.unaPorVencer": "1 quota venç en els pròxims 30 dies.",
  "p.porVencer": "{n} quotes vencen en els pròxims 30 dies.",
  "p.verRenovaciones": "Mira les renovacions",
  "p.pocoStockDe": "Queda poc estoc de {producto}.",
  "p.bajoMinimo": "Hi ha {n} productes per sota de l'estoc mínim.",
  "p.verInventario": "Mira l'inventari",
  "p.dispensadoHoy": "Dispensat avui",
  "p.unaEntrega": "1 lliurament",
  "p.entregas": "{n} lliuraments",
  "p.unSocio": "1 soci",
  "p.socios": "{n} socis",
  "p.entregasASocios": "{entregas} a {socios}",
  "p.aportacionesHoy": "Aportacions d'avui",
  "p.cajaAbierta": "Caixa oberta",
  "p.sinCajaAbierta": "Sense caixa oberta",
  "p.barraHoy": "Barra d'avui",
  "p.sociosActivos": "Socis actius",
  "p.enTotal": "{n} en total",
  "p.esteMes": "Aquest mes",
  "p.enEntregas": "{importe} en {entregas}",
  "p.masDispensado": "El més dispensat avui",
  "p.nadaHoy": "Encara no ha sortit res avui.",
  "p.producto": "Producte",
  "p.entregasColumna": "Lliuraments",
  "p.cantidad": "Quantitat",
  "p.importe": "Import",
  "p.masBarra": "El més venut a la barra avui",
  "p.nadaBarra": "Res de barra avui.",
  "p.cobrosColumna": "Cobraments",
  "p.unidades": "Unitats",
  "p.ultimas": "Últimes dispensacions",
  "p.sinDispensaciones": "Encara no hi ha dispensacions registrades.",
  "p.socio": "Soci",
  "p.fecha": "Data",
  "p.anulada": "Anul·lada",
  "p.primerosPasos": "Primers passos",
  "p.recienCreado": "El club s'acaba de crear. Això és el que convé preparar abans d'obrir el taulell:",
  "p.paso.ajustes": "Revisa els ajustos",
  "p.paso.ajustesResto": ": límit diari i mensual per soci, quota anual i dades de l'associació.",
  "p.paso.catalogo": "Crea les varietats",
  "p.paso.catalogoResto": " amb la seva aportació per gram. Ja tens les categories bàsiques creades.",
  "p.paso.stock": "Posa-hi l'estoc inicial",
  "p.paso.stockResto": " amb una entrada per lot de cada varietat.",
  "p.paso.socio": "Dona d'alta el primer soci",
  "p.paso.socioResto": " i cobra-li la quota.",
  "p.paso.caja": "Obre la caixa",
  "p.paso.cajaResto": " en començar el torn perquè quadri l'efectiu.",
  "p.estadoSocios": "Estat dels socis",
  "p.stockBajo": "Estoc baix",

  "il.buscarSocio": "Cerca un soci",
  "il.nuevoSocio": "Nou soci",
  "il.dispensar": "Dispensa",
  "il.barra": "Barra",
  "il.dentroAhora": "A dins ara",
  "il.aforoCompleto": "Aforament complet",
  "il.hanPasadoHoy": "Han passat avui",
  "il.solicitudes": "Sol·licituds d'alta",
  "il.esperando": "esperant",
  "il.anotarGasto": "Apunta una despesa",

  "pp.paraEmpezar": "Per començar",
  "pp.enEsteOrden": "En aquest ordre és el més ràpid. Això desapareix sol quan ja estigueu en marxa.",
  "pp.hechosDe": "{hechos} de {total}",
  "pp.ir": "Vés",
  "pasos.datos.titulo": "Completa les dades del club",
  "pasos.datos.detalle": "Nom, CIF i adreça. Surten als tiquets i al llibre de socis.",
  "pasos.productos.titulo": "Crea el teu catàleg",
  "pasos.productos.detalle": "Les categories ja hi són. Afegeix el que dispenseu, amb la seva aportació.",
  "pasos.stock.titulo": "Posa-hi l'estoc que tens",
  "pasos.stock.detalle": "Una entrada per lot, amb proveïdor i cost. D'aquí surt la traçabilitat.",
  "pasos.socios.titulo": "Dona d'alta els socis",
  "pasos.socios.detalle": "Un a un, o important el CSV del programa que fèieu servir abans.",
  "pasos.equipo.titulo": "Afegeix el teu equip",
  "pasos.equipo.detalle": "Cada persona amb el seu compte i el seu rol: així el registre diu qui va fer què.",
  "pasos.caja.titulo": "Obre la caixa del dia",
  "pasos.caja.detalle":
    "Amb el fons inicial. En tancar-la, l'arqueig compara el que s'ha comptat amb el que hi hauria d'haver.",

  "as.soloLectura": "El programa està en només lectura.",
  "as.llevaSinRegularizar":
    "La subscripció fa {dias} que no es regularitza. Podeu consultar-ho tot i descarregar les còpies de seguretat des d'Ajustos, però no registrar moviments nous. Tan bon punt es registri el pagament, tot torna al moment.",
  "as.vencioAyer": "La subscripció va vèncer ahir.",
  "as.vencioHace": "La subscripció va vèncer fa {dias}.",
  "as.siSigue":
    "De moment no canvia res. Si continua sense regularitzar-se, el programa passarà a només lectura.",
  "as.venceHoy": "La subscripció venç avui{fecha}.",
  "as.venceManana": "La subscripció venç demà{fecha}.",
  "as.venceEn": "La subscripció venç d'aquí a {dias}{fecha}.",
  "as.entreParentesis": " ({fecha})",
  "as.noHayQueHacer":
    "No cal fer res aquí: la data s'actualitza sola tan bon punt es registri el pagament.",

  "bl.explicacion":
    "La pantalla s'ha blocat sola perquè no es feia servir. Escriu la teva contrasenya per seguir on ho havies deixat.",
  "bl.tuContrasena": "La teva contrasenya",
  "bl.comprobando": "Comprovant...",
  "bl.continuar": "Continua",
  "bl.salirOtraCuenta": "Surt i entra amb un altre compte",
  "bl.fallo": "No s'ha pogut comprovar la contrasenya",

  "ec.sinConexion": "Sense connexió amb el servidor.",
  "ec.sinConexionDesde": "Sense connexió amb el servidor des de les {hora}.",
  "ec.conPaquete":
    "El taulell segueix funcionant amb el que hi ha guardat en aquesta tauleta: els lliuraments s'apunten aquí i s'envien sols quan torni la xarxa.",
  "ec.sinPaquete":
    "Aquesta tauleta no té guardat el catàleg: fins que no torni la xarxa no es pot dispensar.",
  "ec.unaPendiente": "1 lliurament pendent d'enviar.",
  "ec.pendientes": "{n} lliuraments pendents d'enviar.",
  "ec.unaRechazada": "1 rebutjat pel servidor.",
  "ec.rechazadas": "{n} rebutjats pel servidor.",
  "ec.hayRechazada": "Hi ha 1 lliurament que el servidor no ha acceptat: mira-te'l.",
  "ec.hayRechazadas": "Hi ha {n} lliuraments que el servidor no ha acceptat: mira-te'ls.",
  "ec.verCola": "Mira la cua ({n})",
  "ec.enviando": "Enviant...",
  "ec.enviarAhora": "Envia ara",
  "ec.titulo": "Lliuraments guardats en aquesta tauleta",
  "ec.explicacion":
    "Es van fer sense connexió i s'envien soles quan torna la xarxa, en aquest ordre. El servidor els cobra amb els seus imports i apunta el que s'hagués saltat (límit, estoc, saldo) com a incidència del lliurament.",
  "ec.nadaPorEnviar": "No queda res per enviar.",
  "ec.cuando": "Quan",
  "ec.socio": "Soci",
  "ec.que": "Què",
  "ec.importe": "Import",
  "ec.estado": "Estat",
  "ec.rechazada": "Rebutjat: {motivo}",
  "ec.reintentar": "Torna-ho a provar",
  "ec.descartar": "Descarta",
  "ec.confirmarDescartar": "Vols descartar aquest lliurament? No es registrarà enlloc.",
  "ec.pendienteDeEnviar": "Pendent d'enviar",
  "ec.unIntento": " (1 intent)",
  "ec.intentos": " ({n} intents)",

  "gi.titulo": "D'on ve el diner",
  "gi.dias7": "7 dies",
  "gi.dias30": "30 dies",
  "gi.meses12": "12 mesos",
  "gi.dispensacion": "Dispensació",
  "gi.barra": "Barra",
  "gi.cuotas": "Quotes",
  "gi.sinIngresos": "Encara no hi ha ingressos registrats en aquest període.",

  "tb.dejarRecadoEquipo": "Deixa un encàrrec a l'equip",
  "tb.titulo": "Tauler de l'equip",
  "tb.dejarRecado": "Deixa un encàrrec",
  "tb.ejemplo": "El gènere arriba dijous al matí...",
  "tb.fijarArriba": "Fixa'l a dalt",
  "tb.poniendo": "Posant...",
  "tb.poner": "Posa",
  "tb.alguien": "Algú",
  "tb.quitar": "Treu del tauler",

  "dc.titulo": "Cobra la quota a {socio}",
  "dc.cobrando": "Cobrant...",
  "dc.cobrar": "Cobra",
  "dc.importe": "Import (crèdits)",
  "dc.periodo": "Període",
  "dc.unAnio": "1 any",
  "dc.dosAnios": "2 anys",
  "dc.tresAnios": "3 anys",
  "dc.formaDePago": "Forma de pagament",
  "dc.carteraDelSocio": "Cartera del soci",
  "dc.nota": "Si encara li queda període, el nou s'encadena al final; si està vençuda, compta des d'avui.",
  "dc.fallo": "No s'ha pogut cobrar la quota",

  "dr.titulo": "Ingressa a la cartera de {socio}",
  "dr.ingresar": "Ingressa {importe}",
  "dr.tieneAhora": "Ara té",
  "dr.leFaltan": "Li falten {importe} per al que està retirant.",
  "dr.importe": "Import (crèdits)",
  "dr.formaDePago": "Forma de pagament",
  "dr.entraEnCaja": "Entra a la caixa del torn.",
  "dr.noTocaCaja": "No toca la caixa.",
  "dr.seQuedaraCon": "Es quedarà amb",
  "dr.noEsIngreso": "Aquests diners no són un ingrés de l'associació.",
  "dr.esDelSocio": "Són del soci fins que se'ls gasti, i els pot demanar de tornada.",
  "dr.confirmarTitulo": "Has cobrat els diners?",
  "dr.todaviaNo": "Encara no",
  "dr.ingresando": "Ingressant...",
  "dr.siIngresar": "Sí, ingressa",
  "dr.vasASumar": "Sumaràs {importe} a la cartera de {socio}, que passarà a tenir {total}.",
  "dr.confirmoEfectivo": "Confirmo que he cobrat {importe} en efectiu",
  "dr.confirmo": "Confirmo que he cobrat {importe}",
  "dr.siTeEquivocas":
    "Si t'equivoques es pot arreglar des de la fitxa del soci, tornant-li el saldo o ajustant-lo, i queda constància de totes dues coses. Però és molt més fàcil no equivocar-se ara.",
  "dr.fallo": "No s'ha pogut ingressar",

  "cc.entregado": "Lliurat",
  "cc.aCobrar": "A cobrar",
  "cc.cambio": "Canvi",
  "cc.faltan": "Falten {importe}",
  "cc.oEscribelo": "O escriu-ho",
  "cc.poner": "Posa",
  "cc.empezarDeNuevo": "Comença de nou",

  "fp.firmado": "Signat.",
  "fp.estaBien": "Està bé? Confirma-ho.",
  "fp.firmaAqui": "Signa aquí amb el dit o el ratolí.",
  "fp.repetirTitulo": "Repeteix la signatura",
  "fp.repetir": "Repeteix",
  "fp.confirmar": "Confirma",

  "ci.sinCamara": "Aquest navegador no dona accés a la càmera. Puja la imatge des del disc.",
  "ci.sinPermiso":
    "No has donat permís per fer servir la càmera. El pots donar al cadenat de la barra d'adreces.",
  "ci.sinDispositivo": "No s'ha trobat cap càmera. Puja la imatge des del disc.",
  "ci.falloCamara": "No s'ha pogut obrir la càmera. Puja la imatge des del disc.",
  "ci.obligatoria": "Obligatòria",
  "ci.saltada": "Saltada",
  "ci.hacerFoto": "Fes la foto",
  "ci.repetir": "Repeteix",
  "ci.camara": "Càmera",
  "ci.subir": "Puja",
  "ci.quitar": "Treu",

  "cs.titulo": "Contracte de soci",
  "cs.firmoEl": "Va signar la versió {numero} el {fecha}.",
  "cs.firmo": "Va signar la versió {numero}.",
  "cs.sinFirmar":
    "Sense signar. A sota hi ha el d'avui (versió {numero}) amb les seves dades, a punt per imprimir.",
  "cs.verEImprimir": "Mira'l i imprimeix",
  "cs.apuntando": "Apuntant...",
  "cs.marcarFirmado": "Marca'l com a signat",
  "cs.tambienPortal": "També el pot acceptar ell mateix des del seu portal, i aleshores s'apunta sol.",
  "cs.verContratoClub": "Mira el contracte del club",
  "cs.modalTitulo": "Contracte · soci núm. {numero}",
  "cs.noFirmadoAun": "Encara no l'ha signat: això és el document per endur-se'l al taulell.",
  "cs.firmaDelSocio": "Signatura del soci",
  "cs.firmaYSello": "Signatura i segell de l'associació",
  "cs.fallo": "No s'ha pogut apuntar la signatura",

  "sn.titulo": "Nou soci",
  "sn.descripcion": "Es desa al final: fins llavors pots anar i tornar",
  "sn.paso.avalista": "Avalador",
  "sn.paso.datos": "Dades",
  "sn.paso.documento": "Document",
  "sn.paso.contrato": "Contracte",
  "sn.paso.cuota": "Quota",
  "sn.paso.repaso": "Repàs",
  "sn.falta.nombre": "Escriu el nom",
  "sn.falta.apellidos": "Escriu els cognoms",
  "sn.falta.nacimiento": "Falta la data de naixement",
  "sn.falta.documento": "Falta el número del document",
  "sn.falta.foto": "Falta la foto del soci",
  "sn.falta.frente": "Falta el davant del document",
  "sn.falta.reverso": "Falta el revers del document, o marca que no en té",
  "sn.quienAvala": "Qui l'avala?",
  "sn.avalistaNota":
    "Molts estatuts demanen que un soci respongui pel que entra. Si el vostre no, salta-t'ho.",
  "sn.quitar": "Treu",
  "sn.quienEs": "Qui és",
  "sn.nombre": "Nom",
  "sn.apellidos": "Cognoms",
  "sn.nacimiento": "Data de naixement",
  "sn.consumo": "Consum previst (g/mes)",
  "sn.consumoAyuda": "El declara el soci; va al contracte.",
  "sn.telefono": "Telèfon",
  "sn.email": "Correu",
  "sn.dondeVive": "On viu",
  "sn.direccion": "Adreça",
  "sn.ciudad": "Ciutat",
  "sn.cp": "Codi postal",
  "sn.numeroSocio": "Número de soci",
  "sn.numeroAyuda": "Buit: el següent que toqui.",
  "sn.idioma": "Idioma",
  "sn.idiomaAyuda": "En el que veu el portal i rep els correus de la quota.",
  "sn.idiomaDelClub": "El del club",
  "sn.notas": "Notes internes",
  "sn.documento": "Document d'identitat",
  "sn.tipo": "Tipus",
  "sn.pasaporte": "Passaport",
  "sn.numero": "Número",
  "sn.fotoSocio": "Foto del soci",
  "sn.fotoSocioAyuda": "Per reconèixer-lo al taulell",
  "sn.docFrente": "Document, davant",
  "sn.docFrenteAyuda": "La cara amb la foto",
  "sn.docReverso": "Document, revers",
  "sn.noLoTiene": "No en té",
  "sn.docReversoAyuda": "La cara de darrere",
  "sn.sinReverso": "No té revers",
  "sn.fotosHacenFalta":
    "Les fotos calen per donar d'alta: són l'única manera de comprovar després que qui va entrar era qui deia ser. Si no tens càmera, es poden pujar des del disc.",
  "sn.loQueFirma": "El que signa",
  "sn.firma": "Signatura",
  "sn.rgpd": "Ha signat també el consentiment de tractament de dades (RGPD)",
  "sn.sinFirmaSigue":
    "Sense signatura l'alta segueix endavant, però el soci queda com a pendent de signar i ho podrà fer des del seu portal.",
  "sn.cuota": "Quota",
  "sn.cuotaNota": "Cada tipus de soci porta la seva quota, el seu descompte i els seus límits. Es canvien a Ajustos.",
  "sn.sinTipo": "Sense tipus",
  "sn.condicionesGenerales": "Les condicions generals del club",
  "sn.alAnio": "l'any",
  "sn.alAnioLaDelClub": "l'any · la del club",
  "sn.descuentoCatalogo": "−{porcentaje}% al catàleg",
  "sn.sinDescuento": "Sense descompte",
  "sn.cobrarAhora": "Cobra ara",
  "sn.sinCobrarla": "Sense cobrar-la el soci queda pendent i no pot retirar fins que pagui.",
  "sn.formaDePago": "Forma de pagament",
  "sn.repaso": "Repàs",
  "sn.r.nombre": "Nom",
  "sn.r.documento": "Document",
  "sn.r.nacimiento": "Naixement",
  "sn.r.consumo": "Consum declarat",
  "sn.r.gMes": "{n} g/mes",
  "sn.r.avalista": "Avalador",
  "sn.r.sinAvalista": "Sense avalador",
  "sn.r.tipo": "Tipus",
  "sn.r.rgpd": "RGPD",
  "sn.r.firmado": "Signat",
  "sn.r.pendiente": "Pendent",
  "sn.r.contrato": "Contracte",
  "sn.r.pendienteFirma": "Pendent de signatura",
  "sn.loQueSeCobra": "El que es cobra",
  "sn.cuotaAnual": "Quota anual",
  "sn.noSeCobraNada": "Ara no es cobra res: el soci queda pendent.",
  "sn.nadaQueCobrar": "No hi ha res a cobrar.",
  "sn.seCobraEn": "Es cobra en {forma}.",
  "sn.mini.socio": "Soci",
  "sn.mini.frente": "Davant",
  "sn.mini.reverso": "Revers",
  "sn.mini.firma": "Signatura",
  "sn.sinFoto": "Sense foto",
  "sn.atras": "Enrere",
  "sn.creando": "Creant...",
  "sn.crear": "Crea el soci",
  "sn.siguiente": "Següent",
  "sn.fallo": "No s'ha pogut crear el soci",
  "sn.avisoSubida": "El soci està creat, però no s'ha pogut pujar {que}.",
  "sn.subida.foto": "la foto del soci",
  "sn.subida.frente": "el davant del document",
  "sn.subida.reverso": "el revers del document",
  "sn.subida.firma": "la signatura",
  "sn.seAsigna": "(s'assigna al crear)",

  "se.titulo": "Edita {socio}",
  "se.descripcion": "Soci número {numero}",
  "se.guardarCambios": "Desa els canvis",
  "se.datosPersonales": "Dades personals",
  "se.nombre": "Nom *",
  "se.apellidos": "Cognoms *",
  "se.tipoDocumento": "Tipus de document",
  "se.numero": "Número *",
  "se.nacimiento": "Data de naixement *",
  "se.limitesPropios": "Límits propis",
  "se.sinLimites": "Si els deixes buits s'apliquen els del club.",
  "se.sinLimitesConCifras": "Si els deixes buits s'apliquen els del club ({diario} g al dia, {mensual} g al mes).",
  "se.limiteDiario": "Límit diari (g)",
  "se.limiteMensual": "Límit mensual (g)",
  "se.delClub": "Club: {cantidad}",
  "se.asociacion": "Associació",
  "se.tipoDeSocio": "Tipus de soci",
  "se.sinTipo": "Sense tipus (condicions del club)",
  "se.avalista": "Soci avalador",
  "se.buscarAvalista": "Cerca un avalador...",
  "se.rgpd": "Consentiment de tractament de dades (RGPD) signat",
  "se.fallo": "No s'han pogut desar els canvis",

  "lb.volver": "Torna a socis",
  "lb.imprimir": "Imprimeix o guarda en PDF",
  "lb.comoPdf":
    "En imprimir surt només el document, sense els menús. Per guardar-lo com a PDF, tria «Guardar com a PDF» al destí de la impressora.",
  "lb.titulo": "Llibre de socis",
  "lb.emision": "Extracte emès el {fecha} per {quien}.",
  "lb.numero": "Núm.",
  "lb.apellidosNombre": "Cognoms i nom",
  "lb.documento": "Document",
  "lb.nacimiento": "Naixement",
  "lb.alta": "Alta",
  "lb.baja": "Baixa",
  "lb.avalista": "Avalador",
  "lb.rgpd": "RGPD",
  "lb.estado": "Estat",
  "lb.numeroAvalista": "núm. {numero}",
  "lb.si": "Sí",
  "lb.sinSocios": "El registre encara no té cap soci inscrit.",
  "lb.unInscrito": "1 soci inscrit",
  "lb.inscritos": "{n} socis inscrits",
  "lb.enTotal": "en total: {reparto}.",
  "lb.enAlta": "{n} d'alta",
  "lb.suspendidos": "{n} suspesos",
  "lb.pendientes": "{n} pendents d'alta",
  "lb.bajas": "{n} de baixa",
  "lb.consentimiento": "Amb consentiment de tractament de dades signat: {conConsentimiento} de {total}.",
  "lb.consumoDeclarado":
    "Consum declarat pels socis d'alta: {alMes} al mes, que són {alAnio} l'any. És el que van declarar necessitar al donar-se d'alta.",
  "lb.notaPie":
    "Document intern de l'associació, emès a partir del seu registre de socis en la data indicada.",

  "cn.preparando": "Preparant els carnets...",
  "cn.falloPreparar": "No s'han pogut preparar els carnets.",
  "cn.volver": "Torna",
  "cn.unCarnet": "1 carnet",
  "cn.carnets": "{n} carnets",
  "cn.cuantos": "{carnets}, a mida de targeta: vuit per full A4.",
  "cn.cuantosTodos": "{carnets} (tots els socis actius), a mida de targeta: vuit per full A4.",
  "cn.comoImprimir":
    "En imprimir surt només el full de carnets, sense els menús; per guardar-lo en PDF, tria «Guardar com a PDF» al destí de la impressora.",
  "cn.elQr": "El QR és el mateix que el del portal del soci: el taulell el llegeix igual.",
  "cn.ninguno": "No hi ha cap soci per imprimir.",
  "cn.numero": "Núm. {numero}",
  "cn.validoHasta": "Vàlid fins a {fecha}",
  "cn.socioDesde": "Soci des de {fecha}",
  "cn.documentoInterno": "Document intern de l'associació",

  "si.titulo": "Importa socis",
  "si.descripcion": "Porta el registre de socis des d'un altre programa o des d'un full de càlcul",
  "si.volver": "Torna",
  "si.importadoUno": "Importat 1 soci. Ja apareix al registre.",
  "si.importados": "Importats {n} socis. Ja apareixen al registre.",
  "si.verSocios": "Mira els socis",
  "si.otroFichero": "Importa un altre fitxer",
  "si.paso1": "1. Prepara el fitxer",
  "si.explicacion":
    "Un CSV amb una fila per soci. Calen com a mínim «Nom», «Cognoms», «Document» i «Data de naixement», en català o en castellà. Si hi ha columna «Núm. soci» es respecta el número de soci de sempre; si no, s'assignen els següents lliures. La resta (telèfon, correu, adreça, estat, data d'alta, quota fins, notes) es fa servir si hi és. Serveix el fitxer que exporta aquest mateix programa.",
  "si.explicacionNombreEntero":
    "Si el nom i els cognoms venen junts en una sola columna («Nom i cognoms», «Nom complet»), ja els separo jo i t'ensenyo el repartiment abans de desar res.",
  "si.explicacionColumnasDobles":
    "I si venen al contrari, repartits en dues columnes («Primer cognom» i «Segon cognom», o «Primer nom» i «Segon nom»), els ajunto.",
  "si.direccion": "Adreça",
  "si.direccionJuntada":
    "L'adreça venia repartida en diverses columnes («Carrer», «Número», «Pis»…) i l'he ajuntat en una línia, posant davant de cada tros la paraula que fa servir el teu fitxer. Aquí la veus sencera.",
  "si.numeroEnLaCalle":
    "Atenció amb la columna «Número»: com que el fitxer porta l'adreça repartida, l'he llegit com el número del carrer i no com el número de soci. Els números de soci es reparteixen a partir del següent lliure. Si en aquella columna hi havia els teus números de soci, posa-li un altre nom a la del portal («Número carrer») i torna-ho a pujar.",
  "si.explicacionVarios":
    "Quan hi ha diverses columnes per al mateix («Telèfon 1» i «Telèfon 2»), em quedo amb la primera: del soci se'n guarda un telèfon, no tres.",
  "si.explicacionDireccion":
    "L'adreça pot venir partida en «Carrer», «Número», «Pis» i «Porta», i el DNI en número i lletra: ja els ajunto jo.",
  "si.formatos":
    "Dates en format 2026-09-01 o 01/09/2026. Separador «;» o «,». S'accepten fitxers guardats per l'Excel en qualsevol de les seves codificacions.",
  "si.descargarPlantilla": "Descarrega la plantilla",
  "si.falloPlantilla": "No s'ha pogut descarregar la plantilla",
  "si.paso2": "2. Tria el fitxer i analitza'l",
  "si.analizarNoGuarda": "Analitzar no desa res: només comprova el fitxer i et diu què hi troba.",
  "si.analizando": "Analitzant...",
  "si.analizar": "Analitza",
  "si.paso3": "3. Resultat",
  "si.procesando": "Processant el fitxer...",
  "si.eligeFichero": "Tria un fitxer i prem Analitza.",
  "si.filas": "Files",
  "si.validas": "Vàlides",
  "si.conErrores": "Amb errors",
  "si.columnas": "Columnes reconegudes: {columnas}",
  "si.corrige":
    "Corregeix aquestes files al fitxer i torna a analitzar-lo. No s'importa res mentre hi hagi errors.",
  "si.fila": "Fila",
  "si.problema": "Problema",
  "si.numero": "Núm.",
  "si.socio": "Soci",
  "si.nombre": "Nom",
  "si.apellidos": "Cognoms",
  "si.columnasJuntadas":
    "El fitxer porta el cognom (o el nom) repartit en dues columnes i les he ajuntat en una. Aquí no hi ha res a endevinar, surt tal com venia; fes-hi un cop d'ull igualment per confirmar que és l'ordre que esperaves.",
  "si.nombrePartido":
    "El fitxer porta el nom i els cognoms a la mateixa columna i els he separat. No es perd cap tros del nom, però on acaba el nom i on comencen els cognoms és una suposició meva. Repassa-ho aquí abans d'importar: si algun ha quedat mal repartit, s'arregla editant el soci.",
  "si.documento": "Document",
  "si.estado": "Estat",
  "si.seMuestran": "Es mostren {cuantos} de {total}.",
  "si.importarUno": "Importa 1 soci",
  "si.importarVarios": "Importa {n} socis",
  "si.falloLeer": "No s'ha pogut llegir el fitxer",
  "si.falloImportar": "No s'ha pogut importar",

  "sf.volver": "Torna",
  "sf.carnet": "Carnet",
  "sf.editar": "Edita la fitxa",
  "sf.dispensar": "Dispensa",
  "sf.unAnio": "1 any",
  "sf.anios": "{n} anys",
  "sf.subiendo": "Pujant...",
  "sf.cambiarFoto": "Canvia la foto",
  "sf.anadirFoto": "Afegeix una foto",
  "sf.quitarFoto": "Treu la foto",
  "sf.falloQuitarFoto": "No s'ha pogut treure la foto",
  "sf.documento": "Document",
  "sf.alta": "Alta",
  "sf.cuotaHasta": "Quota fins a",
  "sf.avalista": "Avalador",
  "sf.rgpd": "Consentiment RGPD",
  "sf.portal": "Portal del soci",
  "sf.activo": "Actiu",
  "sf.sinAcceso": "Sense accés",
  "sf.cartera": "Cartera",
  "sf.recargar": "Recarrega",
  "sf.cobrarCuota": "Cobra la quota",
  "sf.devolverSaldo": "Torna el saldo",
  "sf.ajustarSaldo": "Ajusta el saldo",
  "sf.suspender": "Suspèn temporalment",
  "sf.levantar": "Aixeca la suspensió",
  "sf.falloLevantar": "No s'ha pogut aixecar",
  "sf.reactivar": "Reactiva el soci",
  "sf.falloReactivar": "No s'ha pogut reactivar",
  "sf.renovarPortal": "Renova l'accés al portal",
  "sf.darPortal": "Dona accés al portal",
  "sf.falloCodigo": "No s'ha pogut generar el codi",
  "sf.retirarPortal": "Retira l'accés al portal",
  "sf.falloRetirar": "No s'ha pogut retirar l'accés",
  "sf.darDeBaja": "Dona de baixa",
  "sf.descargarDatos": "Descarrega les seves dades",
  "sf.falloDescargar": "No s'han pogut descarregar les dades",
  "sf.borrarDatos": "Esborra les seves dades",
  "sf.consumoYLimites": "Consum i límits",
  "sf.hoy": "Avui",
  "sf.esteMes": "Aquest mes",
  "sf.puedeRetirar": "Pot retirar ara",
  "sf.consumoDeclarado": "Consum declarat a l'alta",
  "sf.alMes": "{cantidad}/mes",
  "sf.tab.resumen": "Resum",
  "sf.tab.dispensaciones": "Dispensacions",
  "sf.tab.cartera": "Moviments",
  "sf.tab.cuotas": "Quotes",
  "sf.entregasRegistradas": "Lliuraments registrats",
  "sf.ultimaVisita": "Última visita",
  "sf.cuotasPagadas": "Quotes pagades",
  "sf.notas": "Notes internes",
  "sf.avalados": "Socis avalats",
  "sf.sinDispensaciones": "Aquest soci encara no ha retirat producte.",
  "sf.fecha": "Data",
  "sf.productos": "Productes",
  "sf.cantidad": "Quantitat",
  "sf.importe": "Import",
  "sf.anulada": "Anul·lada",
  "sf.sinCartera": "Sense moviments de cartera.",
  "sf.concepto": "Concepte",
  "sf.saldo": "Saldo",
  "sf.sinCuotas": "Sense quotes registrades.",
  "sf.validaHasta": "Vàlida fins a",
  "sf.codigoPortal": "Codi per al portal del soci",
  "sf.hecho": "Fet",
  "sf.daleLosDatos": "Dona aquestes dades al soci. El codi caduca en 7 dies i només serveix una vegada.",
  "sf.numeroDeSocio": "Número de soci",
  "sf.codigo": "Codi",
  "sf.entraEn": "Entra a {url} i tria «Activa el meu accés».",
  "sf.devolverTitulo": "Torna el saldo al soci",
  "sf.devolverEtiqueta": "Import a tornar",
  "sf.ajustarTitulo": "Ajusta el saldo",
  "sf.ajustarEtiqueta": "Import de l'ajust (negatiu per restar)",
  "sf.bajaTitulo": "Dona de baixa el soci",
  "sf.bajaTexto":
    "El soci deixarà de poder retirar producte. L'historial es conserva. Si té saldo a la cartera cal tornar-lo abans.",
  "sf.suspenderTitulo": "Suspèn temporalment",
  "sf.suspenderTexto":
    "Mentre estigui suspès no podrà entrar ni retirar producte. S'aixeca des d'aquesta mateixa fitxa.",
  "sf.suspenderBoton": "Suspèn",
  "sf.comoMaximo": "Com a màxim {importe} crèdits.",
  "sf.confirmar": "Confirma",
  "sf.motivoObligatorio": "Motiu (obligatori)",
  "sf.motivo": "Motiu",
  "sf.formaDePago": "Forma de pagament",
  "sf.falloAccion": "No s'ha pogut completar l'acció",
  "sf.borrarTitulo": "Esborra les dades del soci",
  "sf.borrando": "Esborrant...",
  "sf.sinVuelta": "Això no té marxa enrere.",
  "sf.seBorra": "S'esborra:",
  "sf.seBorraLista":
    "nom, cognoms, document, data de naixement, telèfon, correu, adreça, foto, notes i el seu accés al portal.",
  "sf.seConserva": "Es conserva:",
  "sf.seConservaLista":
    "el número de soci i les seves dispensacions, quotes, moviments de cartera i accessos. Són la comptabilitat i la traçabilitat del club, i esborrar-los deixaria el llibre descompensat i el rastre dels lots trencat. Queden sense nom al darrere.",
  "sf.copiasDeSeguridad":
    "Les còpies de seguretat fetes abans d'avui segueixen tenint les seves dades: marxaran quan caduquin. Si en el vostre cas cal anar més enllà, consulteu-ho amb el vostre assessor.",
  "sf.escribeNumero": "Escriu el número de soci ({numero}) per confirmar",
  "sf.falloBorrar": "No s'han pogut esborrar les dades",
  "sf.frente": "Davant",
  "sf.reverso": "Revers",
  "sf.sinFoto": "Sense foto",
  "sf.cambiar": "Canvia",
  "sf.subir": "Puja",

  "cu.titulo": "Quotes",
  "cu.descripcion": "El que s'ha cobrat de quotes, i els tipus de soci que hi ha",
  "cu.a": "a",
  "cu.exportar": "Exporta CSV",
  "cu.falloExportar": "No s'ha pogut exportar",
  "cu.tabCobradas": "Cobrades",
  "cu.tabTipos": "Tipus de soci",
  "cu.cobradoEnPeriodo": "Cobrat en el període",
  "cu.unaCuota": "1 quota",
  "cu.cuotas": "{n} quotes",
  "cu.altas": "Altes",
  "cu.altasPie": "Primeres quotes: socis nous",
  "cu.enEfectivo": "En efectiu",
  "cu.enEfectivoPie": "Entra a la caixa del torn",
  "cu.buscar": "Cerca per soci, DNI o concepte",
  "cu.altasYRenovaciones": "Altes i renovacions",
  "cu.soloAltas": "Només altes",
  "cu.soloRenovaciones": "Només renovacions",
  "cu.cualquierTipo": "Qualsevol tipus de soci",
  "cu.cualquierForma": "Qualsevol forma de pagament",
  "cu.cualquierPuesto": "Qualsevol lloc",
  "cu.sinCoincidencias": "Cap quota cobrada amb aquests filtres. Per veure a qui li toca pagar,",
  "cu.miraRenovaciones": "mira Renovacions",
  "cu.fecha": "Data",
  "cu.socio": "Soci",
  "cu.tipoDeSocio": "Tipus de soci",
  "cu.altaORenovacion": "Alta o renovació",
  "cu.periodo": "Període",
  "cu.forma": "Forma",
  "cu.puesto": "Lloc",
  "cu.cobro": "Va cobrar",

  "cu.an.boton": "Anul·la",
  "cu.an.anulada": "Anul·lada",
  "cu.an.titulo": "Anul·lar una quota de {importe}",
  "cu.an.queVaAPasar":
    "Se li tornen {importe} a {socio} i la seva quota deixa de comptar: la data fins a la qual està al dia torna a la de la quota anterior, i si aquesta era l'única no podrà retirar res fins que pagui una altra.",
  "cu.an.deLaCartera": "Com que la va pagar del seu moneder, el saldo li torna a l'instant.",
  "cu.an.delCajon":
    "Com que la va pagar en efectiu, els diners surten del calaix on van entrar. Si aquell torn ja es va tancar no es toca cap caixa: el seu arqueig ja es va signar amb aquesta quota a dins.",
  "cu.an.motivo": "Motiu",
  "cu.an.motivoAyuda":
    "Queda apuntat. D'aquí a sis mesos és l'únic que explicarà aquesta anul·lació.",
  "cu.an.confirmar": "Anul·la la quota",
  "cu.an.anulando": "Anul·lant…",
  "cu.an.fallo": "No s'ha pogut anul·lar la quota",
  "cu.importe": "Import",
  "cu.alta": "Alta",
  "cu.renovacion": "Renovació",
  "cu.tiposTitulo": "Tipus de soci",
  "cu.tiposNota": "Cada tipus porta la seva quota, quant dura, el seu descompte i els seus límits.",
  "cu.seEditanEnAjustes": "Es creen i s'editen a Ajustos",
  "cu.sinTipos": "Sense tipus de soci. Tots paguen la quota general del club.",
  "cu.sinTiposConCuota": "Sense tipus de soci. Tots paguen la quota general del club, {importe} l'any.",
  "cu.tipo": "Tipus",
  "cu.cuota": "Quota",
  "cu.dura": "Dura",
  "cu.descuento": "Descompte",
  "cu.socios": "Socis",
  "cu.apagado": " · apagat",
  "cu.laDelClub": "la del club",
  "cu.unAnio": "1 any",
  "cu.anios": "{n} anys",
  "cu.unMes": "1 mes",
  "cu.meses": "{n} mesos",

  "rn.titulo": "Renovacions",
  "rn.descripcion": "Socis amb la quota vençuda o a punt de vèncer",
  "rn.vencenEnDias": "Vencen en {dias}",
  "rn.cuotaVencida": "Quota vençuda",
  "rn.noPuedenRetirar": "No poden retirar producte",
  "rn.convieneAvisar": "Convé avisar-los",
  "rn.cuotaAnual": "Quota anual",
  "rn.nadieVencida": "Ningú no té la quota vençuda.",
  "rn.vencenEnLosProximos": "Vencen en els pròxims {dias}",
  "rn.ningunaVence": "Cap quota no venç en els pròxims {dias}.",
  "rn.laAsociacion": "l'associació",
  "rn.cobrada": "Quota de {socio} cobrada. Vàlida fins a {fecha}.",
  "rn.socio": "Soci",
  "rn.telefono": "Telèfon",
  "rn.estado": "Estat",
  "rn.cuotaHasta": "Quota fins a",
  "rn.whatsapp": "WhatsApp",
  "rn.mensajeWhatsapp":
    "Hola {nombre}, t'escrivim de {club}. La teva quota de soci està pendent de renovar. Passa't quan puguis pel local. Gràcies.",
  "rn.sinCuota": "Sense quota",
  "rn.vencioHace": "va vèncer fa {dias}",
  "rn.venceHoy": "venç avui",
  "rn.queda": "queda {dias}",
  "rn.quedan": "queden {dias}",
  "rn.cobrarCuota": "Cobra la quota",
  "rn.nadieAQuienAvisar": "No hi havia ningú a qui avisar: o ja se'ls va avisar d'aquesta quota, o encara no venç.",
  "rn.avisadoUno": "Avisat 1 soci ({porCorreo} per correu, {porMovil} al mòbil).",
  "rn.avisados": "Avisats {n} socis ({porCorreo} per correu, {porMovil} al mòbil).",
  "rn.unoSinCorreo": "1 soci sense correu a la fitxa.",
  "rn.sinCorreo": "{n} socis sense correu a la fitxa.",
  "rn.falloRecordatorios": "No s'han pogut enviar els recordatoris",
  "rn.enviando": "Enviant...",
  "rn.avisar": "Avisa els que vencen",

  "gc.gastos": "Despeses",
  "gc.compras": "Compres",
  "gc.proveedores": "Proveïdors",

  "pago.DOMICILIADO": "Domiciliat",

  "ga.titulo": "Despeses i compres",
  "ga.descripcion": "El que surt de l'associació, amb la seva categoria",
  "ga.a": "a",
  "ga.categorias": "Categories",
  "ga.exportar": "Exporta CSV",
  "ga.falloExportar": "No s'ha pogut exportar",
  "ga.nuevo": "+ Despesa",
  "ga.totalFiltrado": "Total del que s'ha filtrat",
  "ga.totalPeriodo": "Total del període",
  "ga.unApunte": "1 apunt",
  "ga.apuntes": "{n} apunts",
  "ga.enEfectivo": "En efectiu",
  "ga.saleDeCaja": "Surt de la caixa del dia",
  "ga.categoriaMayor": "Categoria més gran",
  "ga.porCategoria": "Per categoria",
  "ga.sinGastos": "Sense despeses en aquest període.",
  "ga.gastosDe": "Despeses de {categoria}",
  "ga.todosLosGastos": "Totes les despeses",
  "ga.buscar": "Cerca per concepte, proveïdor o nota",
  "ga.todasCategorias": "Totes les categories",
  "ga.apagada": " (apagada)",
  "ga.cualquierForma": "Qualsevol forma de pagament",
  "ga.cualquierPuesto": "Qualsevol lloc",
  "ga.conPagosProveedor": "Amb els pagaments a proveïdor",
  "ga.verAnulados": "Mira els anul·lats",
  "ga.sinCoincidencias": "Cap despesa amb aquests filtres.",
  "ga.sinApuntes": "No hi ha despeses apuntades en aquest període.",
  "ga.numero": "Núm.",
  "ga.fecha": "Data",
  "ga.concepto": "Concepte",
  "ga.categoria": "Categoria",
  "ga.pago": "Pagament",
  "ga.puesto": "Lloc",
  "ga.importe": "Import",
  "ga.compraNumero": " · Compra #{numero}",
  "ga.anulado": "Anul·lat",
  "ga.anuladoPor": "Anul·lat: {motivo}",
  "ga.editar": "Edita",
  "ga.anular": "Anul·la",
  "ga.d.editar": "Edita la despesa",
  "ga.d.nuevo": "Nova despesa",
  "ga.d.fallo": "No s'ha pogut desar la despesa",
  "ga.d.concepto": "Concepte",
  "ga.d.conceptoEjemplo": "Factura de la llum",
  "ga.d.importe": "Import (crèdits)",
  "ga.d.fecha": "Data",
  "ga.d.categoria": "Categoria",
  "ga.d.formaDePago": "Forma de pagament",
  "ga.d.saldraDeCaja": "Sortirà de la caixa oberta.",
  "ga.d.proveedor": "Proveïdor",
  "ga.d.notas": "Notes",
  "ga.d.editarNota":
    "Editar una despesa no canvia el moviment de caixa que es va apuntar aquell dia: l'arqueig d'aquell torn ja està tancat.",
  "ga.an.titulo": "Anul·la la despesa #{numero}",
  "ga.an.fallo": "No s'ha pogut anul·lar",
  "ga.an.motivo": "Motiu",
  "ga.an.motivoAyuda": "Queda apuntat al costat de la despesa, perquè s'entengui al revisar el mes.",
  "ga.an.motivoEjemplo": "L'import estava malament",
  "ga.an.noSeBorra": "No s'esborra: es queda ratllada a la llista.",
  "ga.an.vuelveALaCaja": " Els diners tornen a la caixa oberta.",
  "ga.an.compraNoPagada": " La compra #{numero} tornarà a figurar com a no pagada.",
  "ga.c.titulo": "Categories de despesa",
  "ga.c.listo": "Llest",
  "ga.c.fallo": "No s'ha pogut",
  "ga.c.ejemplo": "Aigua, Nòmines, Assessoria...",
  "ga.c.anadir": "Afegeix",
  "ga.c.unGasto": "1 despesa",
  "ga.c.gastos": "{n} despeses",
  "ga.c.apagadaNota": "Apagada · no s'ofereix en apuntar",
  "ga.c.seApagara": "S'apagarà: té despeses dins",
  "ga.c.quitarla": "Treu-la",
  "ga.c.quitar": "Treu",
  "ga.c.volverAUsar": "Torna a fer-la servir",
  "ga.c.nota":
    "Una categoria amb despeses dins s'apaga en comptes d'esborrar-se: així els apunts d'anys anteriors segueixen dient de què eren.",

  "co.titulo": "Despeses i compres",
  "co.descripcion": "Comandes a proveïdor, el que arriba i el que es deu",
  "co.nuevaCompra": "+ Compra",
  "co.nuevoProveedor": "+ Proveïdor",
  "co.antesDeLaPrimera":
    "Abans de la primera compra cal donar d'alta el proveïdor, perquè deixi de ser un nom solt i es pugui veure què ha portat i què se li deu.",
  "co.pendienteDePagar": "Pendent de pagar",
  "co.aTodos": "A tots els proveïdors",
  "co.pedidasSinRecibir": "Demanades sense rebre",
  "co.enCamino": "Encarregades i encara en camí",
  "co.sinProveedores": "Encara no hi ha proveïdors.",
  "co.proveedor": "Proveïdor",
  "co.contacto": "Contacte",
  "co.compras": "Compres",
  "co.seLeDebe": "Se li deu",
  "co.sinCompras":
    "Encara no hi ha compres. Al rebre'n una, el seu gènere entra sol al magatzem amb el seu cost i el seu proveïdor, sense tornar a teclejar-lo a Inventari.",
  "co.pedida": "Demanada",
  "co.recibida": "Rebuda",
  "co.anulada": "Anul·lada",
  "co.debe": "Deu {importe}",
  "co.pagada": "Pagada",
  "co.recibidaEl": " · rebuda el {fecha}",
  "co.noEsGenero": " · no és gènere",
  "co.haLlegado": "Ha arribat",
  "co.anular": "Anul·la",
  "co.an.titulo": "Anul·la la compra #{numero}",
  "co.an.quePasa":
    "La compra queda anul·lada i deixa de comptar en el que es deu al proveïdor. L'estoc no es toca: encara no havia arribat.",
  "co.an.motivo": "Motiu (opcional)",
  "co.an.confirmar": "Anul·la la compra",
  "co.an.fallo": "No s'ha pogut anul·lar la compra",
  "co.an.hecho": "Compra #{numero} anul·lada",
  "co.pagar": "Paga",
  "co.recibidaConLotes": "Compra #{numero} rebuda. {lotes} al magatzem.",
  "co.recibidaSinLotes": "Compra #{numero} rebuda.",
  "co.unLote": "1 lot",
  "co.lotes": "{n} lots",
  "co.falloRecibir": "No s'ha pogut rebre",
  "co.p.titulo": "Nou proveïdor",
  "co.p.fallo": "No s'ha pogut desar",
  "co.p.nombre": "Nom",
  "co.p.cif": "CIF o NIF",
  "co.p.telefono": "Telèfon",
  "co.p.email": "Correu",
  "co.p.notas": "Notes",
  "co.n.titulo": "Nova compra",
  "co.n.fallo": "No s'ha pogut desar la compra",
  "co.n.registrar": "Registra · {importe}",
  "co.n.proveedor": "Proveïdor",
  "co.n.referencia": "Albarà o factura",
  "co.n.referenciaAyuda": "Opcional, el número que porta el paper.",
  "co.n.queSeCompra": "Què es compra",
  "co.n.explicacion":
    "Les línies que apunten a un producte del catàleg generen el seu lot al rebre la compra. Les altres —pots, etiquetes, una balança— són despesa i no toquen les existències.",
  "co.n.producto": "Producte",
  "co.n.noEsGenero": "No és gènere",
  "co.n.descripcion": "Descripció",
  "co.n.gramos": "Grams",
  "co.n.coste": "Cost (crèdits)",
  "co.n.otraLinea": "+ Una altra línia",
  "co.n.quitarUltima": "Treu l'última",
  "co.g.titulo": "Paga la compra #{numero}",
  "co.g.fallo": "No s'ha pogut registrar el pagament",
  "co.g.registrar": "Registra el pagament",
  "co.g.quedanPorPagar": "D'aquesta compra queden {importe} per pagar a {proveedor}.",
  "co.g.importe": "Import (crèdits)",
  "co.g.aPlazos": "Es pot pagar a terminis.",
  "co.g.formaDePago": "Forma de pagament",
  "co.g.comoGasto":
    "El pagament s'apunta com a despesa lligada a aquesta compra, perquè els diners surtin una sola vegada als comptes.",
  "co.g.enEfectivo": "En efectiu, surt de la caixa del torn.",

  "do.titulo": "Donacions i ingressos",
  "do.descripcion": "El que donen al club i el que la gent posa a la seva cartera per gastar a dins",
  "do.a": "a",
  "do.exportar": "Exporta CSV",
  "do.falloExportar": "No s'ha pogut exportar",
  "do.nueva": "+ Donació",
  "do.tabDonaciones": "Donacions",
  "do.tabCartera": "Ingressos a la cartera",
  "do.deSuCartera": "De la seva cartera",
  "do.donadoEnPeriodo": "Donat en el període",
  "do.unaDonacion": "1 donació",
  "do.donaciones": "{n} donacions",
  "do.sinNombre": "Sense nom",
  "do.delBote": "De la guardiola, sense soci al darrere",
  "do.enEfectivo": "En efectiu",
  "do.entraEnCaja": "Entra a la caixa del torn",
  "do.ingresadoEnPeriodo": "Ingressat en el període",
  "do.unIngreso": "1 ingrés",
  "do.ingresos": "{n} ingressos",
  "do.clubDebe": "El club deu ara",
  "do.saldoVivo": "Saldo viu a totes les carteres",
  "do.buscar": "Cerca per soci o concepte",
  "do.cualquierForma": "Qualsevol forma de pagament",
  "do.cualquierPuesto": "Qualsevol lloc",
  "do.verAnuladas": "Mira les anul·lades",
  "do.sinDonaciones":
    "Cap donació amb aquests filtres. Serveixen per apuntar els diners que algú dona al club sense que sigui la seva quota ni el que s'emporta.",
  "do.numero": "Núm.",
  "do.fecha": "Data",
  "do.quien": "Qui",
  "do.concepto": "Concepte",
  "do.forma": "Forma",
  "do.puesto": "Lloc",
  "do.atendio": "Ha atès",
  "do.importe": "Import",
  "do.anonima": "Anònima",
  "do.anulada": "Anul·lada",
  "do.anular": "Anul·la",
  "do.sinIngresos":
    "Ningú no ha posat diners a la seva cartera amb aquests filtres. Els ingressos es fan des de la fitxa del soci o des del taulell.",
  "do.socio": "Soci",
  "do.loCobro": "El va cobrar",
  "do.ingresado": "Ingressat",
  "do.saldoDespues": "Saldo després",
  "do.sinDato": "Sense dada",
  "do.r.titulo": "Registra una donació",
  "do.r.fallo": "No s'ha pogut registrar la donació",
  "do.r.registrar": "Registra",
  "do.r.quienDona": "Qui dona",
  "do.r.quienDonaAyuda": "Es pot deixar en blanc: hi ha qui deixa diners a la guardiola sense dir el seu nom.",
  "do.r.quitar": "Treu",
  "do.r.buscarSocio": "Cerca un soci, o deixa-ho en blanc",
  "do.r.importe": "Import (crèdits)",
  "do.r.formaDePago": "Forma de pagament",
  "do.r.faltaSocio": "Per donar des de la cartera cal dir de quin soci.",
  "do.r.efectivoNota": "Entra a la caixa del torn. Les altres formes no la toquen.",
  "do.r.concepto": "Concepte",
  "do.r.conceptoAyuda": "Opcional. Per exemple: guardiola de la barra, rifa, aportació extra.",
  "do.an.titulo": "Anul·la la donació",
  "do.an.fallo": "No s'ha pogut anul·lar",
  "do.an.anulando": "Anul·lant...",
  "do.an.anular": "Anul·la",
  "do.an.explicacion":
    "S'anul·len {importe}. La donació no s'esborra: es marca com a anul·lada i deixa de comptar als comptes. Un ingrés que desapareix de l'historial és un forat a l'arqueig.",
  "do.an.efectivo": "Els diners surten de la caixa oberta amb el seu propi apunt.",
  "do.an.cartera": "Se li torna el saldo al soci.",
  "do.an.motivo": "Motiu",
  "do.an.motivoAyuda": "Opcional, però ajuda a entendre-ho d'aquí a sis mesos.",

  "semana.1c": "Dl",
  "semana.2c": "Dt",
  "semana.3c": "Dc",
  "semana.4c": "Dj",
  "semana.5c": "Dv",
  "semana.6c": "Ds",
  "semana.0c": "Dg",
  "semana.1": "Dilluns",
  "semana.2": "Dimarts",
  "semana.3": "Dimecres",
  "semana.4": "Dijous",
  "semana.5": "Divendres",
  "semana.6": "Dissabte",
  "semana.0": "Diumenge",

  "de.titulo": "Descomptes",
  "de.descripcion": "Campanyes per categoria, producte, tipus de soci, dia i franja horària",
  "de.nuevo": "+ Descompte",
  "de.unoSolo": "un sol descompte, el més gran",
  "de.noSeAcumulan": "que encaixi: no s'acumulen entre ells ni amb el descompte general del tipus de soci.",
  "de.enCadaEntrega": "En cada lliurament s'aplica",
  "de.sinDescuentos": "No hi ha descomptes. Crea'n un per, per exemple, una tarda de flors al 15%.",
  "de.nombre": "Nom",
  "de.descuento": "Descompte",
  "de.aplicaA": "S'aplica a",
  "de.cuando": "Quan",
  "de.estado": "Estat",
  "de.categoriaNombre": "Categoria {nombre}",
  "de.todoElCatalogo": "Tot el catàleg",
  "de.soloTipo": "Només {tipo}",
  "de.todosLosDias": "Tots els dies",
  "de.activo": "Actiu",
  "de.apagado": "Apagat",
  "de.editar": "Edita",
  "de.borrar": "Esborra",
  "de.falloBorrar": "No s'ha pogut esborrar",
  "de.d.editar": "Edita {nombre}",
  "de.d.nuevo": "Nou descompte",
  "de.d.fallo": "No s'ha pogut desar el descompte",
  "de.d.nombre": "Nom",
  "de.d.nombreAyuda": "Surt al tiquet, p. ex. «Tarda tranquil·la».",
  "de.d.porcentaje": "Descompte (%)",
  "de.d.categoria": "Categoria",
  "de.d.categoriaAyuda": "Buit = totes.",
  "de.d.todas": "Totes",
  "de.d.producto": "Producte concret",
  "de.d.productoAyuda": "Buit = tots els de la categoria.",
  "de.d.todos": "Tots",
  "de.d.tipoSocio": "Només per a un tipus de soci",
  "de.d.tipoSocioAyuda": "Buit = per a tots.",
  "de.d.todosLosSocios": "Tots els socis",
  "de.d.dias": "Dies de la setmana",
  "de.d.diasAyuda": "Cap marcat = tots els dies.",
  "de.d.desdeLas": "Des de les",
  "de.d.franjaAyuda": "Franja horària; buit = tot el dia.",
  "de.d.hastaLas": "Fins a les",
  "de.d.fechaInicio": "Data d'inici",
  "de.d.fechaAyuda": "Buit = sense límit.",
  "de.d.fechaFin": "Data de fi",
  "de.d.activo": "Actiu",

  "ca.titulo": "Cartes",
  "ca.descripcion": "El que veuen els socis a la pantalla del local o en escanejar un QR",
  "ca.dispensario": "Dispensari",
  "ca.barra": "Barra",
  "ca.sinCartaBarra": "Sense carta de barra. Si veneu beguda o menjar, aquí és on s'ensenya la llista.",
  "ca.sinCartaDispensario": "Sense carta del dispensari.",
  "ca.principalAyuda": "La que surt a la pantalla del local",
  "ca.principal": "★ Principal",
  "ca.apagada": "Apagada",
  "ca.creadaEl": "Creada el {fecha}",
  "ca.nCategorias": " · {n} categories",
  "ca.verQr": "Mira el QR i l'enllaç",
  "ca.qr": "QR",
  "ca.editar": "Edita",
  "ca.nuevaDe": "+ Carta de {zona}",
  "ca.laPrincipal": "principal",
  "ca.notaPrincipal1": "La",
  "ca.notaPrincipal2":
    "de cada zona és la que surt a la pantalla del local. Les altres s'obren amb el seu propi enllaç, per posar un QR a les taules o enviar-lo a algú.",
  "ca.fallo": "No s'ha pogut",
  "ca.n.titulo": "Nova carta",
  "ca.n.nombreBarra": "Carta de la barra",
  "ca.n.nombreDispensario": "Carta del dispensari",
  "ca.n.crear": "Crea",
  "ca.n.fallo": "No s'ha pogut crear",
  "ca.n.nombre": "Nom",
  "ca.n.nombreAyuda": "Només ho veieu vosaltres, per distingir-les entre elles.",
  "ca.n.avisoBarra": "Ensenyarà el que tingueu donat d'alta a la barra.",
  "ca.n.avisoDispensario": "Ensenyarà el gènere amb estoc. Després la pots limitar a unes categories.",
  "ca.e.nombre": "Nom",
  "ca.e.mensaje": "Missatge",
  "ca.e.mensajeAyuda": "Surt a dalt de tot. Per exemple: horari, o una novetat.",
  "ca.e.categorias": "Categories que ensenya",
  "ca.e.categoriasAyuda": "Cap marcada: les ensenya totes.",
  "ca.e.encendida": "Encesa",
  "ca.e.encendidaAyuda": "Apagada, el seu enllaç deixa d'obrir. No s'esborra res.",
  "ca.e.ponerlaEnPantalla": "Posar-la a la pantalla del local",
  "ca.e.hacerlaPrincipal": "★ Fes-la principal",
  "ca.e.yaNoLaUsais": "Ja no la feu servir",
  "ca.e.confirmarBorrar": "Vols esborrar la carta «{nombre}»? El seu enllaç deixarà d'obrir.",
  "ca.e.borrar": "Esborra",
  "ca.e.falloBorrar": "No s'ha pogut esborrar",
  "ca.e.falloGuardar": "No s'ha pogut desar",
  "ca.q.titulo": "QR de {nombre}",
  "ca.q.apagada": "Aquesta carta està apagada: l'enllaç no obre fins que l'encenguis.",
  "ca.q.enlace": "Enllaç",
  "ca.q.siSeHaFiltrado": "Si l'enllaç s'ha filtrat",
  "ca.q.confirmarRenovar": "Es crearà un enllaç nou i el d'ara deixarà d'obrir. Seguim?",
  "ca.q.cambiarEnlace": "Canvia l'enllaç",
  "ca.q.soloEsta": "Només canvia el d'aquesta carta. Les altres segueixen funcionant.",

  "pd.volver": "Torna",
  "pd.entradasYMermas": "Entrades i minves",
  "pd.stock": "Estoc",
  "pd.minimo": "Mínim {cantidad}",
  "pd.sinMinimo": "Sense mínim definit",
  "pd.aportacion": "Aportació",
  "pd.costeMedio": "Cost mitjà",
  "pd.sinCoste": "Els lots no tenen cost",
  "pd.segunLotes": "Segons els lots amb cost",
  "pd.thcCbd": "THC / CBD",
  "pd.disponible": "Disponible al taulell",
  "pd.retirado": "Retirat del taulell",
  "pd.lotes": "Lots",
  "pd.sinLotes": "Aquest producte no té lots: l'estoc s'ha posat per ajust, sense origen.",
  "pd.lote": "Lot",
  "pd.entrada": "Entrada",
  "pd.origen": "Origen",
  "pd.inicial": "Inicial",
  "pd.queda": "Queda",
  "pd.coste": "Cost",
  "pd.caducidad": "Caducitat",
  "pd.estado": "Estat",
  "pd.consumido": "{n}% consumit",
  "pd.agotado": "Esgotat",
  "pd.caducado": "Caducat",
  "pd.enUso": "En ús",
  "pd.ultimosMovimientos": "Últims moviments",
  "pd.sinMovimientos": "Sense moviments.",
  "pd.fecha": "Data",
  "pd.tipo": "Tipus",
  "pd.detalle": "Detall",
  "pd.cantidad": "Quantitat",
  "pd.stockDespues": "Estoc després",
  "pd.usuario": "Usuari",

  "re.titulo": "Recomptes",
  "re.descripcion": "Pesar el que hi ha i comparar-ho amb el que hi hauria d'haver",
  "re.a": "a",
  "re.empezar": "+ Comença un recompte",
  "re.falloEmpezar": "No s'ha pogut començar el recompte",
  "re.cuadra": "Quadra",
  "re.enMarcha": "Recompte #{numero} en marxa",
  "re.empezado": "Començat {cuando} per {quien}. {contados} de {total} comptats.",
  "re.alguien": "algú",
  "re.conLocalCerrado":
    "Compta amb el local tancat si pots. El que es dispensi mentrestant no es perd, però el descompensament surt més net.",
  "re.seguirContando": "Segueix comptant",
  "re.delPeriodo": "Recomptes del període",
  "re.cerrados": "Tancats",
  "re.todaviaNinguno": "Encara cap",
  "re.descuadreAcumulado": "Descompensament acumulat",
  "re.sumandoTodos": "Sumant tots els del període",
  "re.elPeor": "El pitjor",
  "re.elDiaQueMas": "El dia que més se'n va separar",
  "re.sinCerrados":
    "Sense recomptes tancats en aquest període. Un recompte és pesar tot el que hi ha al tancar i veure si quadra amb el que diu el programa.",
  "re.numero": "Núm.",
  "re.cuando": "Quan",
  "re.quien": "Qui",
  "re.contados": "Comptats",
  "re.saltados": "Saltats",
  "re.descuadre": "Descompensament",
  "re.seCorrigio": "Es va corregir",
  "re.tardo": "Va trigar",
  "re.si": "Sí",
  "re.no": "No",
  "re.unMinuto": "1 minut",
  "re.minutos": "{n} minuts",
  "re.ver": "Mira",
  "re.d.titulo": "Recompte #{numero}",
  "re.d.recuento": "Recompte",
  "re.d.seguirLuego": "Segueix més tard",
  "re.d.cerrarRecuento": "Tanca el recompte",
  "re.d.contadosDe": "{contados} de {total} comptats",
  "re.d.nSaltados": " · {n} saltats",
  "re.d.saltarLoQueQueda": "Salta el que queda ({n})",
  "re.d.descuadre": "Descompensament:",
  "re.d.producto": "Producte",
  "re.d.deberiaHaber": "Hi hauria d'haver",
  "re.d.hay": "Hi ha",
  "re.d.saltarElResto": "Salta la resta",
  "re.d.saltado": "Saltat",
  "re.d.volverAContar": "Torna a comptar-lo",
  "re.d.saltarEste": "Salta aquest producte",
  "re.d.contar": "Compta",
  "re.d.saltar": "Salta",
  "re.d.notas": "Notes:",
  "re.d.seCorrigio": "Al tancar-lo es va corregir l'estoc amb el que s'havia comptat.",
  "re.d.noSeCorrigio":
    "Es va tancar sense corregir l'estoc: el descompensament va quedar apuntat, i res més.",
  "re.d.falloSaltar": "No s'ha pogut saltar",
  "re.d.falloApuntar": "No s'ha pogut apuntar",
  "re.c.titulo": "Tanca el recompte",
  "re.c.volver": "Torna",
  "re.c.cerrando": "Tancant...",
  "re.c.cerrar": "Tanca",
  "re.c.fallo": "No s'ha pogut tancar",
  "re.c.hasContadoUno": "Has comptat 1 producte i el descompensament és de",
  "re.c.hasContado": "Has comptat {n} productes i el descompensament és de",
  "re.c.corregir": "Corregeix l'estoc amb el que s'ha comptat",
  "re.c.corregirAyuda":
    "Se suma la diferència al que hi ha ara, així que si s'ha dispensat alguna cosa mentre comptaves, aquell lliurament segueix comptant. Cada correcció deixa el seu apunt a l'inventari.",
  "re.c.notas": "Notes",
  "re.c.notasAyuda": "Per exemple: per què falta, o què va quedar sense mirar.",
  "re.c.noSeBorra":
    "Un recompte tancat no s'esborra: és el paper que explica el descompensament d'aquell dia.",

  "ct.titulo": "Catàleg",
  "ct.descripcion": "Varietats i productes que dispensa el club",
  "ct.importar": "Importa CSV",
  "ct.marcas": "Marques",
  "ct.nuevaCategoria": "+ Categoria",
  "ct.nuevoProducto": "+ Producte",
  "ct.sinProductos":
    "Encara no hi ha productes al catàleg. Les categories ja hi són: només falta afegir el que dispenseu, amb la seva aportació.",
  "ct.producto": "Producte",
  "ct.categoria": "Categoria",
  "ct.genetica": "Genètica",
  "ct.thcCbd": "THC / CBD",
  "ct.precio": "Aportació",
  "ct.stock": "Estoc",
  "ct.estado": "Estat",
  "ct.bajoMinimo": "sota mínim",
  "ct.activo": "Actiu",
  "ct.inactivo": "Inactiu",
  "ct.editar": "Edita",
  "ct.p.editar": "Edita {nombre}",
  "ct.p.nuevo": "Nou producte",
  "ct.p.fallo": "No s'ha pogut desar el producte",
  "ct.p.nombre": "Nom",
  "ct.p.categoria": "Categoria",
  "ct.p.marca": "Marca",
  "ct.p.sinMarcasAun": "Encara no n'has creat cap.",
  "ct.p.sinMarca": "Sense marca",
  "ct.p.genetica": "Genètica",
  "ct.p.sinEspecificar": "Sense especificar",
  "ct.p.thc": "THC (%)",
  "ct.p.cbd": "CBD (%)",
  "ct.p.aportacionUnidad": "Aportació per unitat (crèdits)",
  "ct.p.aportacionGramo": "Aportació per gram (crèdits)",
  "ct.p.stockMinimo": "Estoc mínim ({unidad})",
  "ct.p.stockMinimoAyuda": "Avisa quan baixi d'aquí.",
  "ct.p.precioPorTipo": "Aportació fixa per tipus de soci",
  "ct.p.sustituye": "Substitueix la del catàleg; el descompte del tipus no s'aplica a sobre.",
  "ct.p.vacioConDescuento": "Buit: catàleg amb −{porcentaje}%",
  "ct.p.vacioCatalogo": "Buit: l'aportació del catàleg",
  "ct.p.descripcion": "Descripció",
  "ct.p.disponible": "Disponible al taulell",
  "ct.c.titulo": "Nova categoria",
  "ct.c.fallo": "No s'ha pogut crear la categoria",
  "ct.c.crear": "Crea",
  "ct.c.nombre": "Nom",
  "ct.c.color": "Color",
  "ct.c.seDispensaPor": "Es dispensa per",
  "ct.c.peso": "Pes (grams)",
  "ct.c.unidades": "Unitats",
  "ct.m.titulo": "Marques",
  "ct.m.listo": "Llest",
  "ct.m.fallo": "No s'ha pogut",
  "ct.m.ejemplo": "Cookies, Green House, de casa...",
  "ct.m.anadir": "Afegeix",
  "ct.m.sinMarcas":
    "Sense marques. Serveixen per saber de qui és cada gènere; si cultiveu el vostre, això us sobra.",
  "ct.m.unProducto": "1 producte",
  "ct.m.productos": "{n} productes",
  "ct.m.apagada": "Apagada",
  "ct.m.apagar": "Apaga",
  "ct.m.encender": "Encén",
  "ct.m.confirmarConProductos": "{productos} es quedaran sense marca. No s'esborra res més. Seguim?",
  "ct.m.confirmarBorrar": "Vols esborrar la marca «{nombre}»?",
  "ct.m.borrar": "Esborra",
  "ct.m.nota":
    "Apagar-la la treu del desplegable però deixa els productes que ja la tenen. Esborrar-la els deixa sense marca, res més.",

  "ci2.titulo": "Importa el catàleg",
  "ci2.descripcion":
    "Porta els productes i l'estoc que teniu des d'un altre programa o des d'un full de càlcul",
  "ci2.volver": "Torna",
  "ci2.importadoUno": "Importat 1 producte. Ja és al catàleg i al taulell.",
  "ci2.importadoUnoConStock":
    "Importat 1 producte amb el seu estoc com a lot d'entrada. Ja és al catàleg i al taulell.",
  "ci2.importados": "Importats {n} productes. Ja són al catàleg i al taulell.",
  "ci2.importadosConStock":
    "Importats {n} productes, {conStock} amb el seu estoc com a lot d'entrada. Ja són al catàleg i al taulell.",
  "ci2.verCatalogo": "Mira el catàleg",
  "ci2.verInventario": "Mira l'inventari",
  "ci2.otroFichero": "Importa un altre fitxer",
  "ci2.paso1": "1. Prepara el fitxer",
  "ci2.explicacion":
    "Un CSV amb una fila per producte. Calen com a mínim «Producte», «Categoria» i «Aportació» (per gram, o per unitat a les categories que van per unitats). També entén els noms en castellà, anglès, neerlandès i alemany, i els que fan servir altres programes: si al teu fitxer diu «Preu», «Precio», «Price», «Prijs» o «Preis», el reconeix igual. Si hi ha «Estoc», entra com un lot amb el seu «Cost», «Proveïdor», «Lot» i «Caducitat» si els poses. La resta (THC, CBD, genètica, estoc mínim, marca, descripció, actiu) es fa servir si hi és.",
  "ci2.formatos":
    "Les categories han d'existir ja al Catàleg, amb la seva unitat: així una errada no crea una categoria nova. Números amb coma o amb punt («8,50» o «8.5»); dates 2027-03-01 o 01/03/2027; separador «;» o «,». S'accepten fitxers guardats per l'Excel.",
  "ci2.descargarPlantilla": "Descarrega la plantilla",
  "ci2.falloPlantilla": "No s'ha pogut descarregar la plantilla",
  "ci2.paso2": "2. Tria el fitxer i analitza'l",
  "ci2.analizarNoGuarda": "Analitzar no desa res: només comprova el fitxer i et diu què hi troba.",
  "ci2.analizando": "Analitzant...",
  "ci2.analizar": "Analitza",
  "ci2.paso3": "3. Resultat",
  "ci2.procesando": "Processant el fitxer...",
  "ci2.eligeFichero": "Tria un fitxer i prem Analitza.",
  "ci2.filas": "Files",
  "ci2.validas": "Vàlides",
  "ci2.conErrores": "Amb errors",
  "ci2.columnas": "Columnes reconegudes: {columnas}",
  "ci2.corrige": "Corregeix aquestes files al fitxer i torna a analitzar-lo. No s'importa res mentre hi hagi errors.",
  "ci2.fila": "Fila",
  "ci2.problema": "Problema",
  "ci2.producto": "Producte",
  "ci2.categoria": "Categoria",
  "ci2.precio": "Aportació",
  "ci2.stock": "Estoc",
  "ci2.seMuestran": "Es mostren {cuantos} de {total}.",
  "ci2.importarUno": "Importa 1 producte",
  "ci2.importarVarios": "Importa {n} productes",
  "ci2.conStock": " ({n} amb estoc)",
  "ci2.falloLeer": "No s'ha pogut llegir el fitxer",
  "ci2.falloImportar": "No s'ha pogut importar",

  "di.titulo": "Dies d'obertura",
  "di.descripcion": "Quins dies ha obert el club i com va anar cadascun",
  "di.a": "a",
  "di.unDiaSinCerrar": "1 dia amb la caixa sense tancar.",
  "di.diasSinCerrar": "{n} dies amb la caixa sense tancar.",
  "di.arqueoNoCuadra": "L'arqueig d'aquells dies no quadra fins que no es tanquin.",
  "di.irACaja": "Vés a Caixa",
  "di.diasAbiertos": "Dies oberts",
  "di.deTantos": "{abiertos} de {total}",
  "di.delPeriodo": "Del període triat",
  "di.entradoEnTotal": "Entrat en total",
  "di.entregasBarraCuotas": "Lliuraments, barra i quotes",
  "di.sociosDistintos": "Socis diferents",
  "di.hanPasado": "Han passat pel club",
  "di.soloAbiertos": "Només els dies que obrim",
  "di.cuandoCuentaAbierto":
    "Un dia compta com a obert tan bon punt algú fitxa, es lliura, es cobra a la barra o s'obre una caixa.",
  "di.noAbrioNinguno": "El club no va obrir cap dia d'aquest període.",
  "di.sinDias": "No hi ha dies en el període triat.",
  "di.dia": "Dia",
  "di.socios": "Socis",
  "di.entregas": "Lliuraments",
  "di.dispensado": "Dispensat",
  "di.barra": "Barra",
  "di.cuotas": "Quotes",
  "di.total": "Total",
  "di.caja": "Caixa",
  "di.cerrado": "Tancat",
  "di.unAlta": "1 alta",
  "di.altas": "{n} altes",
  "di.sinCaja": "Sense caixa",
  "di.sinCerrar": "Sense tancar",
  "di.cuadro": "Va quadrar",
  "di.notaTotal":
    "El total suma lliuraments, barra i quotes. No inclou els ingressos a la cartera, que no són diners del club, ni resta les despeses.",
  "di.diaYNumero": "{dia} {numero}",

  "ac.titulo": "Control d'accés",
  "ac.descripcion": "Registre d'entrada i sortida de socis del local",
  "ac.fallo": "No s'ha pogut registrar l'accés",
  "ac.registrarEntrada": "Registra l'entrada",
  "ac.identificar": "Identifica el soci...",
  "ac.alElegir":
    "Al triar un soci es registra la seva entrada. Si té la quota caducada o està suspès, el sistema ho avisa i no permet l'accés.",
  "ac.socioNumero": "Soci #{numero}",
  "ac.accesoRegistrado": "Accés registrat",
  "ac.cartera": "Cartera: {importe}",
  "ac.cuotaValida": "Quota vàlida fins a {fecha}",
  "ac.irAlMostrador": "Vés al taulell",
  "ac.dentroAhora": "A dins ara",
  "ac.accesosHoy": "Accessos d'avui",
  "ac.enElLocal": "Socis al local",
  "ac.nadieDentro": "No hi ha ningú registrat dins del local.",
  "ac.desde": "des de les {hora}",
  "ac.deHoy": "Accessos d'avui",
  "ac.ningunoHoy": "Encara no s'ha registrat cap accés avui.",
  "ac.hora": "Hora",
  "ac.socio": "Soci",
  "ac.tipo": "Tipus",
  "ac.entrada": "Entrada",
  "ac.salida": "Sortida",

  "co2.titulo": "Contracte de soci",
  "co2.descripcion": "La declaració jurada i les normes que signa qui es dona d'alta",
  "co2.fallo": "No s'ha pogut desar el contracte",
  "co2.sinCambios": "No has canviat res: segueix la versió {numero}.",
  "co2.guardadoConRaros":
    "Desat com a versió {numero}. Atenció: {huecos} no els sé omplir i sortiran tal qual al document.",
  "co2.guardado": "Desat com a versió {numero}.",
  "co2.sinEscribir":
    "Encara no has escrit el contracte. Fins que no ho facis, a les altes no apareixerà res a signar i el soci no ho veurà al seu portal.",
  "co2.versionActual": "Versió actual",
  "co2.numeroVersion": "Núm. {numero}",
  "co2.publicada": "Publicada {fecha}",
  "co2.sinEscribirPie": "Sense escriure",
  "co2.loHanFirmado": "L'han signat",
  "co2.contandoVersiones": "Socis, comptant totes les versions",
  "co2.sinFirmar": "Sense signar",
  "co2.faltanDeAlta": "Socis d'alta que falten",
  "co2.ningunoPendiente": "Cap pendent",
  "co2.elTexto": "El text",
  "co2.elTextoDeHoy": "El text d'avui",
  "co2.ejemplo": "Declaració jurada\n\nEn/Na {{NOMBRE}}, amb {{DNI}}, declara...",
  "co2.seGuardaTalCual":
    "Es desa tal com ho escrius, respectant els salts de línia. Cada vegada que canviïs el text neix una versió nova; l'anterior no s'esborra, perquè qui la va signar va signar aquella.",
  "co2.huecos": "Buits que pots fer servir",
  "co2.huecosAyuda": "Escriu-los entre dobles claus i s'omplen sols amb les dades de cada soci.",
  "co2.versiones": "Versions",
  "co2.sinVersiones": "Encara no n'hi ha cap.",
  "co2.numero": "Núm.",
  "co2.publicadaColumna": "Publicada",
  "co2.firmas": "Signatures",
  "co2.ver": "Mira",
  "co2.sinFirmarCuantos": "Sense signar ({n})",
  "co2.socioColumna": "Soci",
  "co2.deAltaDesde": "D'alta des de",
  "co2.unSocioDeAntes": "1 soci d'abans d'escriure el contracte.",
  "co2.sociosDeAntes": "{n} socis d'abans d'escriure el contracte.",
  "co2.seFirmaDesde": "Es signa des de la seva fitxa, o des del portal si el tenen obert.",
  "co2.v.titulo": "Contracte · versió {numero}",
  "co2.v.publicadaEl": "Publicada el {fecha}.",

  "in.titulo": "Informes",
  "in.descripcion": "Activitat de l'associació en el període triat",
  "in.a": "a",
  "in.porDia": "Per dia",
  "in.porMes": "Per mes",
  "in.aportaciones": "Aportacions",
  "in.unaEntrega": "1 lliurament",
  "in.entregas": "{n} lliuraments",
  "in.dispensado": "Dispensat",
  "in.cuotasCobradas": "Quotes cobrades",
  "in.unaCuota": "1 quota",
  "in.cuotas": "{n} quotes",
  "in.gastos": "Despeses",
  "in.verDesglose": "Mira el desglossament",
  "in.evolucion": "Evolució del dispensat",
  "in.sinActividad": "No hi ha activitat registrada en aquest període.",
  "in.unPeriodo": "1 període",
  "in.periodos": "{n} períodes",
  "in.masDispensados": "Productes més dispensats",
  "in.sinDatos": "Sense dades en el període.",
  "in.producto": "Producte",
  "in.cantidad": "Quantitat",
  "in.masActivos": "Socis més actius",
  "in.socio": "Soci",
  "in.visitas": "Visites",
  "in.queMasAportan": "Els que més aporten",
  "in.nadieHaAportado": "Ningú no ha aportat res en el període.",
  "in.enGenero": "{importe} en gènere",
  "in.enBarra": "{importe} a la barra",
  "in.deCuota": "{importe} de quota",
  "in.donado": "{importe} donat",
  "in.noCuentaCartera":
    "No compta el que hagin posat a la seva cartera: aquells diners encara són seus fins que se'ls gastin.",
  "in.porFormaDePago": "Aportacions per forma de pagament",
  "in.recargasCartera": "Recàrregues de cartera",
  "in.queOpinan": "El que opinen els socis",
  "in.nota": "Nota",
  "in.votos": "Vots",
  "in.queDicen": "El que diuen",
  "in.nadieHaEscrito": "Encara ningú no ha escrit res. Les notes sense comentari sí que compten per a la mitjana.",

  "cm.titulo": "Comunitat",
  "cm.descripcion": "Sol·licituds d'alta i notícies per al portal del soci",
  "cm.nuevaNoticia": "+ Notícia",
  "cm.tabSolicitudes": "Sol·licituds",
  "cm.tabNoticias": "Notícies",
  "cm.pendientes": "Pendents",
  "cm.resueltas": "Resoltes",
  "cm.enlaceAlta": "Enllaç per sol·licitar l'alta",
  "cm.copiarEnlace": "Copia l'enllaç",
  "cm.solicitudesPendientes": "Sol·licituds pendents",
  "cm.sinPendientes": "No hi ha sol·licituds pendents.",
  "cm.recibida": "Rebuda",
  "cm.persona": "Persona",
  "cm.contacto": "Contacte",
  "cm.avalista": "Avalador",
  "cm.nacidoEl": "{documento} · nascut el {fecha}",
  "cm.socioNumero": "Soci núm. {numero}",
  "cm.aprobar": "Aprova",
  "cm.rechazar": "Rebutja",
  "cm.aprobada": "{persona} és ara el soci núm. {numero}, pendent de pagar la quota.",
  "cm.falloAprobar": "No s'ha pogut aprovar",
  "cm.estado": "Estat",
  "cm.resultado": "Resultat",
  "cm.etiquetaAprobada": "Aprovada",
  "cm.etiquetaRechazada": "Rebutjada",
  "cm.sinNoticias": "Sense notícies. Publica'n una i els socis la veuran al seu portal.",
  "cm.fecha": "Data",
  "cm.tituloColumna": "Títol",
  "cm.publicadoPor": "Publicat per",
  "cm.publicada": "Publicada",
  "cm.borrador": "Esborrany",
  "cm.editar": "Edita",
  "cm.borrar": "Esborra",
  "cm.confirmarBorrar": "Vols esborrar «{titulo}»?",
  "cm.n.editar": "Edita la notícia",
  "cm.n.nueva": "Nova notícia",
  "cm.n.fallo": "No s'ha pogut desar la notícia",
  "cm.n.titulo": "Títol",
  "cm.n.texto": "Text",
  "cm.n.textoAyuda": "Els socis ho veuran al seu portal.",
  "cm.n.publicada": "Publicada (si la desmarques queda com a esborrany)",
  "cm.n.avisar": "Avisa el mòbil dels socis",
  "cm.n.avisarAyuda": "Només arriba a qui hagi activat els avisos al seu portal.",
  "cm.n.fotos": "Fotos",
  "cm.n.quitar": "Treu",
  "cm.n.subiendo": "Pujant…",
  "cm.n.otraFoto": "Afegeix una altra foto",
  "cm.n.anadirFotos": "Afegeix fotos",
  "cm.n.escribePrimero":
    "Escriu primer el títol i el text: la notícia es desa en afegir la primera foto.",
  "cm.n.hastaOcho": "Fins a 8 fotos. JPG, PNG o WEBP.",
  "cm.n.falloSubir": "No s'ha pogut pujar la foto",
  "cm.n.falloQuitar": "No s'ha pogut treure la foto",
  "cm.r.titulo": "Rebutja la sol·licitud de {nombre}",
  "cm.r.rechazar": "Rebutja",
  "cm.r.fallo": "No s'ha pogut rebutjar",
  "cm.r.queda":
    "La sol·licitud queda arxivada. El motiu és per al vostre registre: el programa no avisa la persona.",
  "cm.r.motivo": "Motiu (opcional)",

  "aj.titulo": "Ajustos",
  "aj.descripcion": "Dades de l'associació, límits i equip",
  "aj.guardarCambios": "Desa els canvis",
  "aj.guardados": "Ajustos desats.",
  "aj.fallo": "No s'han pogut desar els ajustos",
  "aj.datos": "Dades de l'associació",
  "aj.nombre": "Nom",
  "aj.cif": "CIF",
  "aj.telefono": "Telèfon",
  "aj.direccion": "Adreça",
  "aj.ciudad": "Ciutat",
  "aj.provincia": "Província",
  "aj.cp": "Codi postal",
  "aj.email": "Correu de contacte",
  "aj.reglas": "Regles de dispensació",
  "aj.limiteDiario": "Límit diari (g)",
  "aj.limiteDiarioAyuda": "Per soci i dia.",
  "aj.limiteMensual": "Límit mensual (g)",
  "aj.limiteMensualAyuda": "Per soci i mes natural.",
  "aj.cuotaAnual": "Quota anual (crèdits)",
  "aj.limitesPropios": "Cada soci pot tenir límits propis que substitueixen aquests.",
  "aj.aforo": "Aforament del local",
  "aj.aforoAyuda":
    "El màxim de persones que hi caben, segons la vostra llicència d'activitat. Surt al taulell al costat dels que hi ha dins. Deixa-ho a 0 si no ho vols controlar.",
  "aj.aforoNota":
    "En arribar a l'aforament s'avisa, però no s'impedeix l'entrada: el recompte depèn que la gent marqui la sortida, i tancar-li la porta a un soci per un número que pot estar desajustat seria pitjor que no tenir-lo.",
  "aj.ticket": "Tiquet de lliurament",
  "aj.idiomaPortal": "Idioma del portal del soci",
  "aj.idiomaPortalAyuda":
    "El que fan servir al portal i en què reben els correus de la quota. Cada soci el pot canviar al seu mòbil.",
  "aj.anchoPapel": "Amplada del paper",
  "aj.anchoPapelAyuda": "La de la impressora tèrmica del taulell.",
  "aj.ancho80": "80 mm (estàndard)",
  "aj.ancho58": "58 mm (estret)",
  "aj.textoTicket": "Text del tiquet",
  "aj.textoTicketAyuda": "Surt al peu de cada lliurament.",
  "aj.avisoLegal": "Avís legal",
  "aj.avisoCuota": "Avís automàtic de quota",
  "aj.avisoCuotaNota":
    "Una vegada al dia, el programa avisa per correu (i al mòbil, si tenen el portal instal·lat) els socis a qui els venç la quota. Cada soci rep un sol avís per quota: al renovar, torna a entrar l'any següent.",
  "aj.avisarAuto": "Avisa automàticament",
  "aj.cuantosDiasAntes": "Quants dies abans",
  "aj.cuantosDiasAyuda": "També s'avisa qui ja la té vençuda.",
  "aj.avisoApagado":
    "Ve apagat a propòsit: escriure als vostres socis és decisió del club, no del programa. Des de Renovacions els podeu enviar a mà quan vulgueu, encara que això segueixi apagat.",
  "aj.equipo": "Equip",
  "aj.nuevoUsuario": "+ Usuari",
  "aj.usuario": "Usuari",
  "aj.rol": "Rol",
  "aj.ultimoAcceso": "Últim accés",
  "aj.desactivado": "Desactivat",
  "aj.nunca": "Mai",
  "aj.permisosAMedida": "permisos a mida",

  "permiso.verSocios": "Veure el registre de socis",
  "permiso.crearSocio": "Donar d'alta socis",
  "permiso.editarSocio": "Editar la fitxa d'un soci",
  "permiso.registrarAcceso": "Registrar entrades al local",
  "permiso.dispensar": "Dispensar al taulell",
  "permiso.cobrarCuota": "Cobrar quotes",
  "permiso.recargarCartera": "Recarregar la cartera d'un soci",
  "permiso.verCatalogo": "Veure el catàleg",
  "permiso.venderBarra": "Cobrar a la barra",
  "permiso.gestionarInventario": "Entrades, minves i recomptes",
  "permiso.anularDispensacion": "Anul·lar dispensacions",
  "permiso.suspenderSocio": "Suspendre socis",
  "permiso.gestionarCaja": "Obrir i tancar la caixa",
  "permiso.gestionarGastos": "Apuntar despeses, compres i donacions",
  "permiso.descuentoManual": "Fer descomptes a mà al taulell",
  "permiso.moverGuardado": "Treure gènere del guardat al taulell",
  "permiso.verInformes": "Veure informes i exportar",
  "permiso.ajustarCartera": "Tornar o ajustar el saldo",
  "permiso.gestionarPublicaciones": "Publicar notícies",
  "permiso.gestionarSolicitudes": "Resoldre sol·licituds d'alta",
  "permiso.gestionarCatalogo": "Crear i editar productes",
  "permiso.gestionarBarra": "Gestionar la carta de la barra",
  "permiso.anularCuota": "Anul·lar quotes cobrades",
  "permiso.gestionarUsuarios": "Gestionar l'equip",
  "permiso.ajustesClub": "Canviar els ajustos del club",
  "permiso.bajaSocio": "Donar de baixa socis",
  "permiso.importarSocios": "Importar socis des de CSV",
  "permiso.importarProductos": "Importar catàleg i estoc des de CSV",
  "permiso.verAuditoria": "Veure el registre d'activitat",
  "permiso.borrarDatos": "Esborrar les dades d'un soci",
  "permiso.copiaSeguridad": "Descarregar còpies de seguretat",

  "aj.cs.titulo": "Tanca totes les sessions",
  "aj.cs.explicacion":
    "Fa fora de totes les pantalles tot l'equip, tu inclòs. Per fer fora només una persona no cal això: desactiva-li el compte aquí dalt i queda fora igualment.",
  "aj.cs.boton": "Tanca les sessions de l'equip",
  "aj.cs.queVaAPasar":
    "Cada pantalla oberta tornarà a demanar la contrasenya la propera vegada que parli amb el servidor, en uns segons. La teva també.",
  "aj.cs.loPendiente":
    "Els lliuraments ja cobrats que estiguin sense enviar no es perden: esperen a la tauleta i s'envien sols tan bon punt algú torni a entrar.",
  "aj.cs.confirmar": "Tanca les sessions",
  "aj.cs.cerrando": "Tancant…",
  "aj.cs.fallo": "No s'han pogut tancar les sessions",
  "aj.editar": "Edita",
  "aj.tiposDeSocio": "Tipus de soci",
  "aj.nuevoTipo": "+ Tipus",
  "aj.sinTipos": "Sense tipus. Crea per exemple «Col·laborador» amb un 10% de descompte i quota reduïda.",
  "aj.tipo": "Tipus",
  "aj.descuento": "Descompte",
  "aj.cuota": "Quota",
  "aj.dura": "Dura",
  "aj.limites": "Límits",
  "aj.socios": "Socis",
  "aj.laDelClub": "la del club",
  "aj.losDelClub": "els del club",
  "aj.limitesDiaMes": "{diario} / dia · {mensual} / mes",
  "aj.registro": "Registre d'activitat",
  "aj.sinRegistros": "Sense registres.",
  "aj.sistema": "sistema",
  "aj.copia": "Còpia de seguretat",
  "aj.copiaNota":
    "Descarrega les dades i guarda-les xifrades fora del local. Les fotos dels socis estan a la carpeta «uploads» del servidor i no van a dins.",
  "aj.copiaDatos": "Dades del club (JSON)",
  "aj.copiaBase": "Base de dades completa (.db)",
  "aj.falloCopia": "No s'ha pogut descarregar la còpia",
  "aj.variosClubes":
    "La instal·lació té diversos clubs: la còpia completa del servidor la fa qui l'administra.",
  "aj.copiasAuto": "Còpies automàtiques",
  "aj.copiasAutoNota": "El programa guarda una còpia cada nit i conserva les dels últims 14 dies.",
  "aj.sinCopiasAun":
    "Encara no n'hi ha cap: la primera es fa aquesta nit. Tot i així, guarda'n tu també una fora del servidor de tant en tant.",
  "aj.u.titulo": "Nou usuari de l'equip",
  "aj.u.fallo": "No s'ha pogut crear l'usuari",
  "aj.u.crear": "Crea",
  "aj.u.nombre": "Nom",
  "aj.u.email": "Correu",
  "aj.u.contrasena": "Contrasenya",
  "aj.u.minimo": "Mínim 8 caràcters.",
  "aj.u.rol": "Rol",
  "aj.u.trabajadorLargo": "Treballador — el dia a dia: taulell, socis, inventari i caixa",
  "aj.e.titulo": "Edita {nombre}",
  "aj.e.fallo": "No s'ha pogut desar l'usuari",
  "aj.e.nombre": "Nom",
  "aj.e.rol": "Rol",
  "aj.e.puesto": "Lloc",
  "aj.e.puestoAyuda": "Decideix a quina caixa cau el que cobra aquesta persona. Sense lloc, a la caixa del club.",
  "aj.e.sinPuesto": "Sense lloc",
  "aj.e.nuevaContrasena": "Contrasenya nova",
  "aj.e.nuevaContrasenaAyuda": "Deixa-la buida per no canviar-la. Mínim 8 caràcters.",
  "aj.e.cuentaActiva": "Compte actiu",
  "aj.e.noTuPropia": "No pots desactivar el teu propi compte.",
  "aj.e.desactivada": "Un compte desactivat no pot entrar, però conserva el seu historial.",
  "aj.e.permisos": "Permisos",
  "aj.e.permisosAyuda":
    "El rol marca el que pot fer per defecte. Aquí pots fer excepcions per a aquesta persona: el que canviïs queda ressaltat.",
  "aj.e.concedido": "concedit",
  "aj.e.retirado": "retirat",
  "aj.e.volverAlRol": "Torna als permisos del rol",
  "aj.t.editar": "Edita {nombre}",
  "aj.t.nuevo": "Nou tipus de soci",
  "aj.t.fallo": "No s'ha pogut desar el tipus",
  "aj.t.falloBorrar": "No s'ha pogut esborrar el tipus",
  "aj.t.borrar": "Esborra",
  "aj.t.nombre": "Nom",
  "aj.t.color": "Color",
  "aj.t.descripcion": "Descripció",
  "aj.t.descuento": "Descompte general (%)",
  "aj.t.descuentoAyuda":
    "Sobre l'aportació del catàleg, tret que el producte tingui una aportació fixa per a aquest tipus.",
  "aj.t.cuota": "Quota anual (crèdits)",
  "aj.t.cuotaAyuda": "Buit = la quota del club. 0 = sense quota.",
  "aj.t.duracion": "Quant dura (mesos)",
  "aj.t.duracionAyuda": "12 és el normal. Amb 1, el soci paga cada mes.",
  "aj.t.limiteDiario": "Límit diari (g)",
  "aj.t.limiteDiarioAyuda": "Buit = el del club.",
  "aj.t.limiteMensual": "Límit mensual (g)",
  "aj.t.orden": "Ordre",
  "aj.t.activo": "Actiu (es pot assignar a socis nous)",
  "aj.p.titulo": "Llocs de treball",
  "aj.p.nota":
    "Si al club es cobra des de més d'un lloc a la vegada —el taulell i la barra, cadascun amb el seu calaix—, crea un lloc per a cadascun i assigna a cada persona el seu des de l'equip. Cada lloc obre i quadra la seva pròpia caixa.",
  "aj.p.nota2": "Si no en crees cap, tot segueix com fins ara: una sola caixa per al club sencer.",
  "aj.p.inactivo": " · inactiu",
  "aj.p.unaPersona": "1 persona",
  "aj.p.personas": "{n} persones",
  "aj.p.desactivar": "Desactiva",
  "aj.p.activar": "Activa",
  "aj.p.falloCambiar": "No s'ha pogut canviar",
  "aj.p.ejemplo": "Taulell, Barra...",
  "aj.p.anadir": "Afegeix",
  "aj.p.fallo": "No s'ha pogut crear el lloc",

  "su.titulo": "La teva subscripció",
  "su.prueba": "En període de prova",
  "su.pruebaCaducada": "Prova acabada",
  "su.alDia": "Al dia",
  "su.moroso": "Pendent de pagament",
  "su.suspendido": "Suspès",
  "su.sinCoste": "Sense cost",
  "su.alMes": "{importe} al mes",
  "su.sinCuota": "Aquest club no té quota: pots fer servir el programa sense pagar res.",
  "su.bloqueado":
    "La subscripció fa {dias} que no es regularitza i el programa està en només lectura. Podeu consultar-ho tot i descarregar les còpies de seguretat; tan bon punt es registri el pagament, tot torna.",
  "su.vencioAyer": "Va vèncer ahir. De moment tot segueix funcionant amb normalitat.",
  "su.vencioHace": "Va vèncer fa {dias}. De moment tot segueix funcionant amb normalitat.",
  "su.pruebaTermina": "La prova s'acaba el {fecha}, {cuando}.",
  "su.periodoHasta": "El període pagat arriba fins al {fecha}, {cuando}.",
  "su.hoy": "avui",
  "su.manana": "demà",
  "su.enDias": "d'aquí a {dias}",
  "su.sinFecha": "No hi ha cap data de venciment registrada.",
  "su.pagos": "Pagaments registrats",
  "su.sinPagos": "Encara no hi ha cap pagament registrat.",
  "su.fecha": "Data",
  "su.importe": "Import",
  "su.cubreHasta": "Cobreix fins a",
  "su.forma": "Forma",
  "su.recibo": "Rebut",
  "su.metodo.TRANSFERENCIA": "Transferència",
  "su.metodo.EFECTIVO": "Efectiu",
  "su.metodo.DOMICILIACION": "Domiciliació",
  "su.metodo.TARJETA": "Targeta",
  "su.metodo.OTRO": "Altre",
  "su.r.imprimir": "Imprimeix o guarda en PDF",
  "su.r.suscripcion": "Subscripció al programa de gestió",
  "su.r.recibidoDe": "Rebut de",
  "su.r.fechaDelPago": "Data del pagament",
  "su.r.concepto": "Concepte",
  "su.r.conceptoTexto": "Subscripció al programa de gestió, fins al {fecha}",
  "su.r.formaDePago": "Forma de pagament",
  "su.r.importe": "Import",
  "su.r.justificante":
    "Justificant del pagament registrat. No substitueix la factura, que emet qui presta el servei.",

  "en.titulo": "Gestió del club",
  "en.subtitulo": "Entra amb el teu compte de l'equip",
  "en.email": "Correu",
  "en.contrasena": "Contrasenya",
  "en.club": "Club",
  "en.eligeClub": "Tria el club...",
  "en.variosClubes": "Aquest correu pertany a diversos clubs: tria'n un.",
  "en.entrando": "Entrant...",
  "en.cola.una":
    "En aquesta tauleta queda un lliurament sense enviar: es va fer sense xarxa i s'enviarà sol tan bon punt entris.",
  "en.cola.varias":
    "En aquesta tauleta en queden {cuantas} sense enviar: són lliuraments fets sense xarxa i s'enviaran sols tan bon punt entris.",
  "en.entrar": "Entra",
  "en.fallo": "No s'ha pogut iniciar la sessió",
  "en.olvidada": "He oblidat la contrasenya",
  "en.aunNoEsta": "El vostre club encara no hi és?",
  "en.darloDeAlta": "Dona'l d'alta",
  "en.queEs": "Què és asocis",

  "rc.titulo": "He oblidat la contrasenya",
  "rc.subtitulo": "T'enviem un enllaç al correu del teu compte",
  "rc.email": "Correu",
  "rc.enviando": "Enviant...",
  "rc.enviar": "Envia'm l'enllaç",
  "rc.fallo": "No s'ha pogut enviar el correu",
  "rc.miraSpam": "Mira també a la carpeta de correu no desitjat. L'enllaç caduca en una hora.",
  "rc.volver": "Torna a l'entrada",
  "rc.nueva": "Contrasenya nova",
  "rc.cambiada": "Contrasenya canviada. Et portem a l'entrada...",
  "rc.entrarAhora": "Entra ara",
  "rc.nuevaEtiqueta": "Contrasenya nova",
  "rc.minimo": "Mínim 8 caràcters.",
  "rc.repitela": "Repeteix-la",
  "rc.noCoinciden": "Les dues contrasenyes no coincideixen.",
  "rc.cambiar": "Canvia la contrasenya",
  "rc.falloCambiar": "No s'ha pogut canviar la contrasenya",

  "rg.cerrado": "Alta de clubs tancada",
  "rg.cerradoTexto":
    "Aquesta instal·lació no admet crear clubs nous des del web. Parla amb qui administra el servidor perquè et doni accés.",
  "rg.volverAEntrar": "Torna a entrar",
  "rg.titulo": "Dona d'alta un club",
  "rg.subtitulo": "Crees l'associació i el teu compte de propietari",
  "rg.nombreClub": "Nom de l'associació",
  "rg.nombreClubEjemplo": "Associació Cannàbica...",
  "rg.ciudad": "Ciutat",
  "rg.tuNombre": "El teu nom",
  "rg.tuEmail": "El teu correu",
  "rg.tuEmailAyuda": "Serà el teu usuari per entrar.",
  "rg.contrasena": "Contrasenya",
  "rg.minimo": "Mínim 8 caràcters.",
  "rg.repite": "Repeteix la contrasenya",
  "rg.codigo": "Codi de llicència",
  "rg.codigoAyuda": "El que et van donar al contractar. Té aquesta forma: ASOC-XXXX-XXXX.",
  "rg.acepto": "He llegit i accepto l'",
  "rg.avisoLegal": "avís legal",
  "rg.yLa": "i la",
  "rg.privacidad": "política de privacitat",
  "rg.creando": "Creant el club...",
  "rg.crear": "Crea el club",
  "rg.yaTeneis": "Ja teniu club?",
  "rg.entrar": "Entra",
  "rg.noCoinciden": "Les dues contrasenyes no coincideixen",
  "rg.fallo": "No s'ha pogut crear el club",
};
